import React, { useState, useEffect, useCallback, useRef } from 'react';
import confetti from 'canvas-confetti';
import { createPortal } from 'react-dom';
import './App.css';
import ShinyText from './ShinyText';
import Silk from './Silk';
import { ProfileIcon } from './ProfileIcons';
import { ReactComponent as EditIcon } from './icons/edit_square_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg';
import { ReactComponent as BoltIcon } from './icons/bolt_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg';
import { ReactComponent as PowerIcon } from './icons/power_settings_new_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg';
import { ReactComponent as PasskeyIcon } from './icons/passkey_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg';
import { ReactComponent as CommunicationIcon } from './icons/communication_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg';

function buildUserInitBody(extra = {}) {
  const webApp = window.Telegram?.WebApp;
  return {
    initData: webApp?.initData || '',
    start_param: extra.start_param ?? (webApp?.initDataUnsafe?.start_param || ''),
    ...extra
  };
}

// Вставляю функцию forceButtonStyles обратно в начало файла:
function forceButtonStyles() {
  // Принудительно применяем стили к кнопкам для совместимости с Telegram Web App
  const orangeButtons = document.querySelectorAll('.nvpn-btn-orange');
  orangeButtons.forEach(button => {
    button.style.background = 'linear-gradient(135deg, #ff9100, #ff6f00)';
    button.style.color = '#fff';
    button.style.cursor = 'pointer';
  });

  const darkButtons = document.querySelectorAll('.nvpn-btn-dark');
  darkButtons.forEach(button => {
    button.style.background = 'linear-gradient(135deg, #ff9100, #ff6f00)';
    button.style.color = '#fff';
    button.style.cursor = 'pointer';
  });
  const orangeMainButtons = document.querySelectorAll('.nvpn-btn-orange-main');
  orangeMainButtons.forEach(button => {
    button.style.background = 'linear-gradient(135deg, #ea5022, #d4451e)';
    button.style.color = '#fff';
    button.style.border = '2px solid rgba(255, 255, 255, 0.2)';
    button.style.cursor = 'pointer';
    button.style.setProperty('background', 'linear-gradient(135deg, #ea5022, #d4451e)', 'important');
    button.style.setProperty('color', '#ffffff', 'important');
    button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
    button.style.setProperty('cursor', 'pointer', 'important');
    
    // Снимаем фокус с кнопки если активна
    if (document.activeElement === button) {
      button.blur();
    }
    
    // Удаляем Telegram CSS переменные если они есть
    button.style.setProperty('--tg-theme-button-color', 'transparent', 'important');
    button.style.setProperty('--tg-theme-button-text-color', '#ffffff', 'important');
    button.style.setProperty('transition', 'none', 'important');
  });
  
  const orangeSetupButtons = document.querySelectorAll('.nvpn-btn-orange-setup');
  orangeSetupButtons.forEach(button => {
    button.style.background = 'linear-gradient(135deg, #ff9100, #ff6f00)';
    button.style.color = '#fff';
    button.style.border = '2px solid rgba(255, 255, 255, 0.2)';
    button.style.cursor = 'pointer';
    button.style.setProperty('background', 'linear-gradient(135deg, #ff9100, #ff6f00)', 'important');
    button.style.setProperty('color', '#ffffff', 'important');
    button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
    button.style.setProperty('cursor', 'pointer', 'important');
    
    if (document.activeElement === button) {
      button.blur();
    }
    
    button.style.setProperty('--tg-theme-button-color', 'transparent', 'important');
    button.style.setProperty('--tg-theme-button-text-color', '#ffffff', 'important');
  });
  
  const orangePaymentButtons = document.querySelectorAll('.nvpn-btn-orange-payment');
  orangePaymentButtons.forEach(button => {
    button.style.background = 'linear-gradient(90deg, #ea5022, #d4451e)';
    button.style.color = '#fff';
    button.style.border = '1px solid rgba(0, 0, 0, 0.2)';
    button.style.cursor = 'pointer';
    button.style.setProperty('background', 'linear-gradient(90deg, #ea5022, #d4451e)', 'important');
    button.style.setProperty('color', '#ffffff', 'important');
    button.style.setProperty('border', '1px solid rgba(0, 0, 0, 0.2)', 'important');
    button.style.setProperty('cursor', 'pointer', 'important');
    
    if (document.activeElement === button) {
      button.blur();
    }
    
    button.style.setProperty('--tg-theme-button-color', 'transparent', 'important');
    button.style.setProperty('--tg-theme-button-text-color', '#ffffff', 'important');
    button.style.setProperty('transition', 'none', 'important');
  });
  
  const mainButtons = document.querySelectorAll('.nvpn-btn-main');
  mainButtons.forEach(button => {
    button.style.background = 'linear-gradient(90deg, #ea5022, #d4451e)';
    button.style.color = '#fff';
    button.style.border = 'none';
    button.style.cursor = 'pointer';
    button.style.setProperty('background', 'linear-gradient(90deg, #ea5022, #d4451e)', 'important');
    button.style.setProperty('color', '#ffffff', 'important');
    button.style.setProperty('border', 'none', 'important');
    button.style.setProperty('cursor', 'pointer', 'important');
    button.style.setProperty('transition', 'none', 'important');
    button.style.setProperty('WebkitTransition', 'none', 'important');
    button.style.setProperty('MozTransition', 'none', 'important');
    
    if (document.activeElement === button) {
      button.blur();
    }
    
    button.style.setProperty('--tg-theme-button-color', 'transparent', 'important');
    button.style.setProperty('--tg-theme-button-text-color', '#ffffff', 'important');
  });

  
  // Агрессивное принуждение стилей для всех кнопок с оранжевым градиентом (legacy)
  const orangeGradientButtons = document.querySelectorAll('.nvpn-btn[style*="linear-gradient(135deg, #ea5022"], .nvpn-btn[style*="ea5022"]');
  orangeGradientButtons.forEach(button => {
    // Снимаем фокус с кнопки
    if (document.activeElement === button) {
      button.blur();
    }
    
    // Принудительно применяем стили
    button.style.background = 'linear-gradient(135deg, #ea5022, #d4451e)';
    button.style.color = '#ffffff';
    button.style.border = '2px solid rgba(255, 255, 255, 0.2)';
    button.style.cursor = 'pointer';
    button.style.setProperty('background', 'linear-gradient(135deg, #ea5022, #d4451e)', 'important');
    button.style.setProperty('color', '#ffffff', 'important');
    button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
    button.style.setProperty('cursor', 'pointer', 'important');
    
    // Удаляем Telegram CSS переменные если они есть
    button.style.setProperty('--tg-theme-button-color', 'transparent', 'important');
    button.style.setProperty('--tg-theme-button-text-color', '#ffffff', 'important');
    button.style.setProperty('transition', 'none', 'important');
  });
  
  // Дополнительная защита - устанавливаем CSS переменные для всей страницы
  document.documentElement.style.setProperty('--tg-theme-button-color', 'transparent', 'important');
  document.documentElement.style.setProperty('--tg-theme-button-text-color', '#ffffff', 'important');
}

const TARIFFS = [
  { label: '1 месяц', price: [150, 240, 310, 375, 435], perMonth: [150, 120, 103, 94, 87], days: 30 },
  { label: '3 месяца', price: [390, 620, 790, 975, 1130], perMonth: [130, 206, 263, 325, 376], days: 90 },
  { label: '6 месяцев', price: [720, 1150, 1470, 1800, 2080], perMonth: [120, 191, 245, 300, 346], popular: true, days: 180 },
  { label: '1 год', price: [1320, 2110, 2700, 3300, 3820], perMonth: [110, 175, 225, 275, 318], days: 365 },
];

function formatDatePlusDays(days, user = null) {
  let startDate = new Date();
  
  // Если у пользователя есть активная подписка, считаем от её окончания
  if (user && user.tariff && user.tariff !== 'trial' && user.sub_end) {
    const subEndDate = new Date(user.sub_end);
    const now = new Date();
    
    // Если подписка ещё активна, добавляем дни к дате окончания подписки
    if (subEndDate > now) {
      startDate = subEndDate;
    }
    // Если подписка истекла, считаем от текущего момента
  }
  
  startDate.setDate(startDate.getDate() + days);
  return startDate.toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' });
}

function Loader() {
  return <div style={{display:'flex',justifyContent:'center',alignItems:'center',margin:'24px 0'}}>
    <div className="nvpn-loader" style={{width:36,height:36,border:'4px solid #ea5022',borderTop:'4px solid #000',borderRadius:'50%',animation:'spin 1s linear infinite'}} />
    <style>{`@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}`}</style>
  </div>;
}

function pluralizeDevice(n) {
  // 1 устройство, 2-4 устройства, 5-20 устройств, 21 устройство, 22-24 устройства и т.д.
  const last = n % 10, last2 = n % 100;
  if (last === 1 && last2 !== 11) return `${n} устройство`;
  if ([2,3,4].includes(last) && ![12,13,14].includes(last2)) return `${n} устройства`;
  return `${n} устройств`;
}

function pluralizeDeviceGenitive(n) {
  // Родительный падеж: до 2/3/4/5/21/22/25 устройств
  const last = n % 10, last2 = n % 100;
  if (last === 1 && last2 !== 11) return `${n} устройства`;
  return `${n} устройств`;
}

function MainStatusCard({ user, setUser, showUpgradeModal, setShowUpgradeModal, onReturnToMain }) {
  const devices = user.tariff ? parseInt(user.tariff.match(/(\d+)devices$/)?.[1] || '1', 10) : 1;
  const isActive = user.tariff && user.tariff !== 'trial' && new Date(user.sub_end) > new Date();
  const currentTariffIdx = TARIFFS.findIndex(t => user.tariff && user.tariff.startsWith(t.label.replace(' ', '').toLowerCase()));
  const canUpgrade = isActive && devices < 5 && currentTariffIdx !== -1;
  const isMax = isActive && devices >= 5;
  return (
    <>
      <div style={{
        marginBottom: 18,
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}>
        <div style={{
          display:'flex',
          justifyContent:'space-between',
          alignItems:'flex-start',
          marginBottom:2,
          gap: '8px'
        }}>
          <div style={{
            fontWeight:700,
            fontSize:'1.15em',
            color:'#ea5022',
            letterSpacing:'0.01em',
            lineHeight:'1.3',
            flex: '1',
            marginRight: '8px'
          }}>
            {user.sub_end ? (
              <>
                <div style={{fontSize:'1em', marginBottom:'4px'}}>
                  до: {new Date(user.sub_end).toLocaleDateString('ru-RU', {
                    year: 'numeric',
                    month: window.innerWidth < 350 ? 'short' : 'long',
                    day: 'numeric'
                  }).replace(/[\s\u00A0\u202F]*г\.?$/i, '')}
                </div>
                <div style={{fontSize:'0.95em',fontWeight:500}}>
                  {isActive ? 'подписка активна' : (user.tariff !== 'trial' ? 'подписка истекла' : 'пробный период')}
                </div>
              </>
            ) : '—'}
          </div>
          {isActive && (
            <button
              className="status-device-btn"
              style={{
                background: 'linear-gradient(90deg,#ea5022,#d4451e)',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '8px 12px',
                fontWeight: 600,
                fontSize: '0.9em',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                cursor: 'pointer',
                minWidth: window.innerWidth < 350 ? '90px' : '110px',
                boxShadow: '0 2px 8px 0 rgba(234,80,34,0.18)',
                transition: 'all 0.2s ease',
                outline: '2px solid #ea5022',
                flexShrink: 0
              }}
              onClick={() => { triggerHaptic(); setShowUpgradeModal(true); }}
            >
              <span style={{fontSize: window.innerWidth < 350 ? '0.85em' : '0.9em'}}>
                {window.innerWidth < 320 ? `${devices}` : pluralizeDevice(devices)}
              </span>
              <EditIcon width={window.innerWidth < 350 ? 16 : 18} height={window.innerWidth < 350 ? 16 : 18} />
            </button>
          )}
        </div>
      </div>
      {showUpgradeModal && <UpgradeDevicesModal user={user} onClose={()=>{ triggerHaptic(); setShowUpgradeModal(false); }} setUser={setUser} onReturnToMain={onReturnToMain} />}
    </>
  );
}

function PurchaseScreen({ user, selection, setSelection, onBack, setUser }) {
  const [modalStep, setModalStep] = useState(null); // null | 'confirm' | 'method' | 'waiting' | 'success'
  const [payMethod, setPayMethod] = useState('bank_card');
  const [loading, setLoading] = useState(false);
  const [payUrl, setPayUrl] = useState('');
  const [paymentId, setPaymentId] = useState('');
  const [prevStatus, setPrevStatus] = useState(null);
  const [prevTariff, setPrevTariff] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [successSubEnd, setSuccessSubEnd] = useState(null); // дата окончания подписки после оплаты
  const [showUpgrade, setShowUpgrade] = useState(false);
  const isActive = user.tariff && user.tariff !== 'trial' && new Date(user.sub_end) > new Date();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState(null);
  const [errorModal, setErrorModal] = useState(null);
  
  // При продлении подписки обновляем количество устройств до текущего
  useEffect(() => {
    if (isActive) {
      const currentDevices = parseInt(user.tariff.match(/(\d+)devices$/)?.[1] || '1', 10);
      setSelection(prev => ({
        ...prev,
        devices: currentDevices
      }));
    }
  }, [isActive, user.tariff, setSelection]);

  // Проверяем localStorage при монтировании
  useEffect(() => {
    // Убираем всю логику с localStorage - она не нужна
    console.log('==> MOUNT EFFECT: Component mounted');
  }, []);

  // Загрузка сохранённых карт при открытии модального окна выбора оплаты
  useEffect(() => {
    if ((modalStep === 'method' || modalStep === 'confirm') && user?.telegram_id) {
      fetch('/api/user/payment-methods', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ telegram_id: user.telegram_id })
      })
        .then(res => res.json())
        .then(data => setPaymentMethods(data.payment_methods || []))
        .catch(() => setPaymentMethods([]));
    }
  }, [modalStep, user?.telegram_id]);

  // Автоматическая проверка статуса платежа
  useEffect(() => {
    let intervalId;
    
    if (modalStep === 'waiting' && paymentId && user?.telegram_id) {
      console.log('==> Starting payment status polling for:', paymentId);
      console.log('==> Current user telegram_id:', user.telegram_id);
      
      intervalId = setInterval(async () => {
        console.log('==> Checking payment status...');
        try {
          const res = await fetch('/api/payment/status', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ payment_id: paymentId, telegram_id: user.telegram_id })
          });
          
          if (!res.ok) {
            console.error('==> Payment status response not ok:', res.status, res.statusText);
            return;
          }
          
          const data = await res.json();
          console.log('==> Payment status check result:', data);
          
          if (data.status === 'succeeded') {
            console.log('==> Payment succeeded! Switching to success modal');
            clearInterval(intervalId);
            setModalStep('success');
            // Обновляем данные пользователя с небольшой задержкой
            setTimeout(async () => {
              try {
                const userRes = await fetch('/api/user/init', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(buildUserInitBody())
                });
                if (userRes.ok) {
                  const userData = await userRes.json();
                  console.log('==> Updated user data after payment:', userData);
                  setUser(userData);
                  setSuccessSubEnd(userData.sub_end); // <-- теперь дата берётся из обновлённого пользователя
                }
              } catch (userError) {
                console.error('==> Error updating user data:', userError);
              }
            }, 1500); // Ждем 1.5 секунды, чтобы бэкенд успел обработать изменения
            // Запускаем конфетти
            showConfetti();
            // Третий залп справа
            setTimeout(() => {
              confetti({
                particleCount: 50,
                angle: 120,
                spread: 55,
                origin: { x: 1 }
              });
            }, 400);
          }
        } catch (error) {
          console.error('==> Error checking payment status:', error);
        }
      }, 2000); // Проверяем каждые 2 секунды для быстрого отклика
    } else {
      console.log('==> Not starting polling. modalStep:', modalStep, 'paymentId:', paymentId, 'telegram_id:', user?.telegram_id);
    }
    
    return () => {
      if (intervalId) {
        console.log('==> Clearing payment status polling interval');
        clearInterval(intervalId);
      }
    };
  }, [modalStep, paymentId, user?.telegram_id]);

  useEffect(() => {
    const tg = window.Telegram && window.Telegram.WebApp;
    if (tg && tg.setHeaderColor) {
      tg.setHeaderColor('#020202');
    }
  }, []);

  useEffect(() => {
    if (user) {
      console.log('==> USER EFFECT: User changed', { 
        prevTariff, 
        currentTariff: user.tariff, 
        isTrialToPaid: prevTariff && user.tariff !== prevTariff && user.tariff !== 'trial'
      });
      // Показываем конфетти, если тариф изменился и стал не trial
      if (prevTariff && user.tariff !== prevTariff && user.tariff !== 'trial') {
        console.log('==> USER EFFECT: Launching confetti!');
        showConfetti();
      }
      setPrevTariff(user.tariff);
    }
  }, [user]);

  // Добавляем глобальный метод для обновления пользователя после оплаты
  useEffect(() => {
    window.updateUserFromPayment = (data) => {
      console.log('==> GLOBAL UPDATE: updateUserFromPayment called with data:', data);
      setUser(data);
      setLoading(false);
      
      // Если пользователь перешел с trial на платный тариф, показываем конфетти
      if (data.tariff && data.tariff !== 'trial' && prevTariff === 'trial') {
        console.log('==> GLOBAL UPDATE: User upgraded from trial to paid, showing confetti');
        showConfetti();
      }
      
      console.log('==> GLOBAL UPDATE: User state updated');
    };
    return () => { 
      console.log('==> GLOBAL UPDATE: Cleaning up updateUserFromPayment');
      window.updateUserFromPayment = undefined; 
    };
  }, [prevTariff]);

  // Добавляем обработчик возврата в приложение
  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (document.visibilityState === 'visible' && modalStep === 'waiting' && paymentId && user?.telegram_id) {
        try {
          const API_URL = window.location.hostname.includes('nitroovpn.ru')
            ? 'https://nitroovpn.ru'
            : '';
          const statusRes = await fetch(`${API_URL}/api/yookassa/check-payment`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ payment_id: paymentId, telegram_id: user.telegram_id })
          });
          if (statusRes.ok) {
            const statusData = await statusRes.json();
            if (statusData.status === 'succeeded' || statusData.status === 'already_processed') {
              let subEnd = user.sub_end;
              // Обновляем данные пользователя с задержкой
              setTimeout(async () => {
                const userRes = await fetch('/api/user/init', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(buildUserInitBody())
                });
                if (userRes.ok) {
                  const userData = await userRes.json();
                  console.log('==> Updated user data from visibility change:', userData);
                  if (typeof window.updateUserFromPayment === 'function') {
                    window.updateUserFromPayment(userData);
                  }
                  subEnd = userData.sub_end;
                }
              }, 1500);
              setSuccessSubEnd(subEnd);
              setModalStep('success');
              setPayUrl('');
              setPaymentId('');
              setLoading(false);
              setPaymentSuccess(false);
              localStorage.removeItem('paymentSuccess');
              
              // Запускаем конфетти при успешной оплате
              showConfetti();
            }
          }
        } catch (e) {
          // Можно добавить обработку ошибок, если нужно
        }
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [paymentSuccess, modalStep, paymentId, user]);

  const handleDevicesChange = (e) => {
    setSelection(prev => ({
      ...prev,
      devices: Number(e.target.value)
    }));
    const tg = window.Telegram && window.Telegram.WebApp;
    if (tg && tg.HapticFeedback) {
      tg.HapticFeedback.impactOccurred('soft');
    }
  };

  const handlePay = async () => {
    setLoading(true);
    setPayUrl('');
    
    const devicesToSend = selection.devices;
    const amount = TARIFFS[selection.tariffIndex].price[devicesToSend - 1].toFixed(2);
    let description;
    if (payMethod === 'saved_card' && selectedPaymentMethodId) {
      description = `Ручной автоплатёж: ${TARIFFS[selection.tariffIndex].label}, устройств: ${devicesToSend}`;
    } else {
      description = `${isActive ? 'Продление' : 'Тариф'}: ${TARIFFS[selection.tariffIndex].label}, устройств: ${devicesToSend}`;
    }

    if (payMethod === 'saved_card' && selectedPaymentMethodId) {
      try {
        const res = await fetch('/api/yookassa/pay-with-saved-card', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            telegram_id: user.telegram_id,
            amount,
            description,
            payment_method_id: selectedPaymentMethodId
          })
        });
        const data = await res.json();
        if (data.status === 'succeeded') {
          // Платеж создан успешно, webhook обработает его
          setModalStep('waiting');
          setPaymentId(data.payment_id);
          // Убираем немедленное обновление данных - webhook сделает это
        } else {
          setErrorModal('Платёж не прошёл. Попробуйте другой способ оплаты или обратитесь в поддержку.');
          setModalStep('error');
        }
      } catch (e) {
        setErrorModal('Платёж не прошёл. Попробуйте другой способ оплаты или обратитесь в поддержку.');
        setModalStep('error');
      } finally {
        setLoading(false);
      }
      return;
    }
    
    const API_URL = window.location.hostname.includes('nitroovpn.ru')
      ? 'https://nitroovpn.ru'
      : '';
    try {
      const res = await fetch(`${API_URL}/api/yookassa/create-payment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount,
          description,
          method: payMethod,
          telegram_id: user?.telegram_id,
          return_context: 'purchase' // Контекст для возврата на экран покупки
        })
      });
          const data = await res.json();
    console.log('Payment creation result:', data);
    if (data.confirmation_url) {
      setPayUrl(data.confirmation_url);
      setPaymentId(data.payment_id);
      setModalStep('waiting');
    } else {
      alert('Ошибка создания платежа: ' + (data.error || 'Неизвестная ошибка'));
    }
    } catch (e) {
      alert('Ошибка соединения с сервером оплаты');
    } finally {
      setLoading(false);
    }
  };

  const endDate = formatDatePlusDays(TARIFFS[selection.tariffIndex].days, user);

  // Единое всплывающее окно (нижний бар)
  const renderModal = () => {
    if (!modalStep) return null;

    const devicesToShow = selection.devices;
    const priceToShow = TARIFFS[selection.tariffIndex].price[devicesToShow - 1];

    console.log('==> MODAL DEBUG:', {
      modalStep,
      isActive,
      selectionDevices: selection.devices,
      devicesToShow,
      priceToShow,
      tariffIndex: selection.tariffIndex,
      userTariff: user.tariff
    });

    return (
      <div className="nvpn-center" style={{zIndex: 1000, pointerEvents: 'auto'}}>
        <div className="nvpn-card" style={{maxWidth: 420, width: '100%', margin: 0, padding: 0, borderRadius: '22px 22px 18px 18px'}}>
          <button className="modal-close" style={{position:'absolute',top:10,right:16}} onClick={() => { triggerHaptic(); setModalStep(null); }}>&times;</button>
          {modalStep === 'confirm' && (
            <div style={{padding: '32px 24px 24px 24px'}}>
              <div className="modal-header" style={{color:'#fff', fontWeight:700}}>Подтверждение</div>
              <div className="modal-body" style={{color:'#ea5022'}}>
                <div style={{marginBottom:12}}>Подписка до: <b>{endDate}</b></div>
                <div style={{marginBottom:12}}>Количество устройств: <b>{devicesToShow}</b></div>
                <div className="confirm-pay-row" style={{display:'flex',alignItems:'center',marginBottom:18,background:'#23262b',borderRadius:12,padding:'0 8px',gap:8}}>
                  <span style={{fontSize:'1.3em',color:'#ea5022',padding:'0 8px'}}>+</span>
                  <span style={{flex:1, fontWeight:500, color:'#fff',fontSize:'1.08em',padding:'14px 0'}}>
                    {payMethod === 'sbp'
                      ? 'Оплата новым счётом СБП'
                      : payMethod === 'saved_card' && selectedPaymentMethodId
                        ? (() => {
                            const card = paymentMethods.find(m => m.payment_method_id === selectedPaymentMethodId);
                            return card
                              ? `Оплата сохранённой картой ${card.card_type} •••• ${card.card_last4}`
                              : 'Оплата сохранённой картой';
                          })()
                        : 'Оплата новой картой'
                    }
                  </span>
                  <button className="change-method-btn" style={{background:'none',border:'none',color:'#ea5022',fontWeight:600,fontSize:'1.1em',display:'flex',alignItems:'center',cursor:'pointer',padding:'0 8px'}} onClick={() => { triggerHaptic(); setModalStep('method'); }}>
                    Изменить <span style={{fontSize:'1.2em',marginLeft:4}}>&#8250;</span>
                  </button>
                </div>
                <button className="nvpn-btn nvpn-btn-orange-payment confirm-btn" style={{width:'100%', fontSize:'0.98rem', padding:'13px 0', animation: loading ? 'none' : 'shine 2s ease-in-out infinite'}} onClick={() => { triggerHaptic(); handlePay(); }} disabled={loading}>
                  {loading ? 'Создание оплаты...' : `Оплатить ${priceToShow} ₽`}
                </button>
              </div>
            </div>
          )}
          {modalStep === 'method' && (
            <div style={{padding: '32px 24px 24px 24px'}}>
              <div className="modal-header payment-method" style={{color:'#ea5022'}}>
                <span className="back-arrow" style={{color:'#ea5022'}} onClick={() => { triggerHaptic(); setModalStep('confirm'); }}>&larr;</span>
                Изменить способ оплаты
              </div>
              <div className="modal-body">
                {paymentMethods.length > 0 && (
                  <div style={{marginBottom: 16}}>
                    {paymentMethods.map(method => (
                      <button
                        key={method.payment_method_id}
                        className="nvpn-btn nvpn-btn-orange-payment"
                        style={{
                          marginBottom: 8,
                          border: selectedPaymentMethodId === method.payment_method_id ? '2px solid #ea5022' : undefined
                        }}
                        onClick={() => {
                          triggerHaptic();
                          setSelectedPaymentMethodId(method.payment_method_id);
                          setPayMethod('saved_card');
                          setModalStep('confirm');
                        }}
                      >
                        💳 {method.card_type} •••• {method.card_last4}
                      </button>
                    ))}
                  </div>
                )}
                <button className="nvpn-btn nvpn-btn-orange-payment" style={{marginBottom:12}} onClick={() => { triggerHaptic(); setPayMethod('sbp'); setModalStep('confirm'); }}>
                  <span role="img" aria-label="sbp">🏦</span> Оплата новым счётом <b>СБП</b>
                </button>
                <button className="nvpn-btn nvpn-btn-orange-payment" onClick={() => { triggerHaptic(); setPayMethod('bank_card'); setModalStep('confirm'); }}>
                  <span role="img" aria-label="card">💳</span> Оплата новой картой
                </button>
              </div>
            </div>
          )}
          {modalStep === 'waiting' && (
            <div style={{padding: '32px 24px 24px 24px', textAlign:'center'}}>
              <div className="modal-body" style={{color:'#ea5022'}}>
                <div style={{marginBottom:12}}>
                  Оплатите счёт в сервисе ЮKassa
                </div>
                <Loader />
                <button className="nvpn-btn nvpn-btn-orange-payment" style={{marginTop:12}} onClick={() => { triggerHaptic(); if(window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.openLink) window.Telegram.WebApp.openLink(payUrl); else window.open(payUrl, '_blank'); }}>
                  Перейти на форму оплаты
                </button>
              </div>
            </div>
          )}
          {modalStep === 'success' && (
            <PurchaseSuccessModal successSubEnd={successSubEnd} onBack={onBack} setModalStep={setModalStep} />
          )}
          {modalStep === 'error' && (
            <div style={{padding: '32px 24px 24px 24px', textAlign:'center'}}>
              <div style={{fontSize: '1.5em', fontWeight: 700, color: '#ff6b6b', marginBottom: 12}}>Ошибка оплаты</div>
              <div style={{fontSize: '2.5em', color: '#ff6b6b', marginBottom: 18}}>❌</div>
              <div style={{color:'#fff', fontSize:'1.1em', marginBottom:18}}>{errorModal}</div>
              <button className="nvpn-btn nvpn-btn-main" style={{
                width:'100%',
                fontSize:'1.1em',
                marginTop:8,
                background: 'linear-gradient(90deg,#ea5022,#d4451e) !important',
                color: '#fff !important',
                fontWeight: 700,
                border: 'none !important',
                borderRadius: 16,
                boxShadow: '0 4px 24px rgba(234,80,34,0.10)',
                padding: '14px 0',
                transition: 'none !important',
                WebkitTransition: 'none !important',
                MozTransition: 'none !important'
              }} onClick={() => { triggerHaptic(); setErrorModal(null); setModalStep('method'); }}>
                Вернуться к выбору оплаты
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="purchase-screen">
      {/* Анимированный Silk фон */}
      <Silk 
        speed={5}
        scale={1}
        color="#181c20"
        noiseIntensity={1.5}
        rotation={0}
      />
      <div className="purchase-body">
        <div className="tariffs-card-bg">
          {isActive ? (
            <>
              <div style={{marginBottom: 10, marginTop: 0, textAlign: 'left'}}>
                <div style={{fontWeight: 700, color: '#fff', fontSize: '1.18em', marginBottom: 2}}>Продление подписки</div>
                <div style={{color: '#ea5022', fontSize: '1em', opacity: 0.85}}>Выберите интересующий тариф и количество устройств</div>
              </div>
              <button
                className="nvpn-btn"
                style={{
                  width: '100%',
                  marginBottom: 18,
                  background: 'rgba(24,28,32,0.68)',
                  color: '#fff',
                  border: '1.5px solid rgba(255,255,255,0.08)',
                  fontSize: '1.1em',
                  padding: '16px 0',
                  boxShadow: '0 8px 32px 0 rgba(0,0,0,0.13), 0 1.5px 8px 0 rgba(0,0,0,0.06)',
                  backdropFilter: 'blur(32px)'
                }}
                onClick={() => { triggerHaptic(); setShowUpgrade(true); }}
              >
                Изменить количество устройств
              </button>
            </>
          ) : (
            <>
              <div className="purchase-label">Количество устройств: {selection.devices}</div>
              <input
                type="range"
                min={1}
                max={5}
                value={selection.devices}
                onChange={handleDevicesChange}
                className="purchase-slider-range"
              />
              <div className="purchase-slider-labels">
                {[1,2,3,4,5].map(val => (
                  <span key={val} className={val === selection.devices ? 'active' : ''}>{val}</span>
                ))}
              </div>
            </>
          )}
          <div className="tariffs-grid">
            {TARIFFS.map((tariff, idx) => (
              <div
                key={tariff.label}
                className={`tariff-card${selection.tariffIndex === idx ? ' selected' : ''}`}
                onClick={() => { triggerHaptic(); setSelection(prev => ({ ...prev, tariffIndex: idx })); }}
              >
                <div className="tariff-label-row">
                  <span className="tariff-label">{tariff.label}</span>
                </div>
                <div className="tariff-price">
                  {tariff.price[selection.devices-1]} ₽
                </div>
                {tariff.label !== '1 месяц' && (
                  <div className="tariff-permonth">
                    {tariff.perMonth[selection.devices-1]}₽ в месяц
                  </div>
                )}
                {tariff.label === '6 месяцев' && (
                  <div className="tariff-popular" style={{marginTop: 8}}>
                    <ShinyText text="популярный" speed={3} />
                  </div>
                )}
              </div>
            ))}
          </div>
          <div style={{marginTop: 32, width: '100%'}}>
            <button className="nvpn-btn nvpn-btn-orange-payment" style={{width: '100%'}} onClick={() => { triggerHaptic(); setModalStep('confirm'); }}>
              {`Оплатить ${TARIFFS[selection.tariffIndex].price[selection.devices-1]} ₽`}
            </button>
          </div>
        </div>
      </div>
      {showUpgrade && <UpgradeDevicesModal user={user} onClose={() => { triggerHaptic(); setShowUpgrade(false); }} setUser={setUser} onReturnToMain={onBack} />}
      {renderModal()}
    </div>
  );
}

function PurchaseSuccessModal({ successSubEnd, onBack, setModalStep }) {
  return (
    <div style={{
      padding: '32px 24px 24px 24px',
      textAlign: 'center',
      background: 'rgba(35,24,27,0.98)',
      borderRadius: 22,
      boxShadow: '0 8px 32px 0 rgba(0,0,0,0.22)',
      color: '#fff',
      maxWidth: 380,
      margin: '0 auto',
      position: 'relative',
    }}>
      <div style={{
        fontSize: '1.5em',
        fontWeight: 700,
        color: '#fff',
        marginBottom: 12,
        letterSpacing: 0.2,
        textShadow: '0 2px 8px rgba(0,0,0,0.10)'
      }}>Успешно оплачено</div>
      <div style={{color:'#fff', fontSize:'1.1em', marginBottom:18}}>
        Ваша подписка продлена до <b>{successSubEnd ? new Date(successSubEnd).toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' }) : ''}</b>
      </div>
      <div style={{margin:'24px 0'}}>
        <span style={{
          display:'inline-block',
          border:'2.5px solid #ea5022',
          borderRadius:'50%',
          width:64,
          height:64,
          margin:'0 auto',
          lineHeight:'64px',
          fontSize:'2.5em',
          color:'#fff',
          background:'#23181b',
          boxShadow:'0 2px 8px rgba(234,80,34,0.18)'
        }}>&#10003;</span>
      </div>
      <button className="nvpn-btn nvpn-btn-main" style={{
        width:'100%',
        fontSize:'1.1em',
        marginTop:8,
        background: 'linear-gradient(90deg,#ea5022,#d4451e)',
        color: '#fff',
        fontWeight: 700,
        border: 'none',
        borderRadius: 16,
        boxShadow: '0 4px 24px rgba(234,80,34,0.10)',
        padding: '14px 0',
        transition: 'none'
      }} onClick={() => { 
        triggerHaptic(); 
        setModalStep(null); 
        onBack(); 
        setTimeout(() => { showConfetti(); }, 100);
      }}>
        Вернуться на главную
      </button>
    </div>
  );
}

function ConfirmDialog({ title, message, onConfirm, onCancel, confirmText = 'Удалить', noConfirmHaptic = false }) {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      zIndex: 1002,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'linear-gradient(160deg, #1e2328 0%, #2a2f35 100%)',
        borderRadius: '20px',
        padding: '28px 24px',
        maxWidth: '340px',
        width: '100%',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{
          color: '#fff',
          fontSize: '1.2em',
          fontWeight: '700',
          marginBottom: '16px',
          textAlign: 'center'
        }}>
          {title}
        </div>
        
        <div style={{
          color: '#fff',
          fontSize: '1.05em',
          lineHeight: '1.4',
          marginBottom: '28px',
          textAlign: 'center'
        }}>
          {message}
        </div>
        
        <div style={{
          display: 'flex',
          gap: '12px'
        }}>
          <button
            onClick={() => { triggerHaptic(); onCancel(); }}
            style={{
              flex: 1,
              background: 'rgba(255, 255, 255, 0.1)',
              border: 'none',
              borderRadius: '12px',
              padding: '14px 16px',
              color: '#fff',
              fontSize: '1.05em',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.15)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.1)';
            }}
          >
            Отмена
          </button>
          
          <button
            onClick={() => { 
              if (!noConfirmHaptic) triggerHaptic(); 
              onConfirm(); 
            }}
            style={{
              flex: 1,
              background: 'linear-gradient(90deg, #ff6b6b, #ff5252)',
              border: 'none',
              borderRadius: '12px',
              padding: '14px 16px',
              color: '#fff',
              fontSize: '1.05em',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 4px 12px rgba(255, 107, 107, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 16px rgba(255, 107, 107, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(255, 107, 107, 0.3)';
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

function PaymentProfileScreen({ onBack, user }) {
  const [autoRenew, setAutoRenew] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmDialog, setConfirmDialog] = useState(null);

  // Загружаем методы оплаты при монтировании
  useEffect(() => {
    const fetchPaymentMethods = async () => {
      if (!user?.telegram_id) return;
      
      try {
        const response = await fetch('/api/user/payment-methods', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ telegram_id: user.telegram_id })
        });
        
        if (response.ok) {
          const data = await response.json();
          setPaymentMethods(data.payment_methods || []);
          // Устанавливаем статус автопродления из первого метода
          if (data.payment_methods && data.payment_methods.length > 0) {
            setAutoRenew(Boolean(data.payment_methods[0].auto_renewal_enabled));
          }
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchPaymentMethods();
  }, [user]);

  // Кнопка назад в шапке Telegram
  useEffect(() => {
    const tg = window.Telegram && window.Telegram.WebApp;
    if (tg && tg.BackButton) {
      tg.BackButton.show();
      tg.BackButton.onClick(() => { triggerHaptic(); onBack(); });
    }
    return () => {
      if (tg && tg.BackButton) {
        tg.BackButton.hide();
        tg.BackButton.offClick && tg.BackButton.offClick();
      }
    };
  }, [onBack]);

  const handleAutoRenewToggle = async () => {
    if (!user?.telegram_id) return;
    
    const newValue = !autoRenew;
    
    // Вибрация СРАЗУ при нажатии кнопки (для любого действия)
    triggerHaptic();
    
    // Если пользователь хочет отключить автопродление, показываем алерт
    if (autoRenew && !newValue) {
      const endDate = user.sub_end ? 
        new Date(user.sub_end).toLocaleDateString('ru-RU', { 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        }) : 'неизвестна';
      
      setConfirmDialog({
        title: 'Отмена автопродления',
        message: `Ваша подписка останется активной до ${endDate}\n\nЧтобы продлить подписку вручную, нажмите «Продлить подписку» на главном экране.`,
        confirmText: 'Отключить автопродление',
        onConfirm: () => {
          setConfirmDialog(null);
          performAutoRenewToggle(newValue, true); // флаг skipHaptic = true
        },
        onCancel: () => setConfirmDialog(null)
      });
    } else {
      // Если включаем автопродление, работаем как обычно
      performAutoRenewToggle(newValue, true); // флаг skipHaptic = true (вибрация уже была)
    }
  };

  const performAutoRenewToggle = async (newValue, skipHaptic = false) => {
    try {
      const response = await fetch('/api/user/auto-renewal', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          telegram_id: user.telegram_id, 
          enabled: newValue 
        })
      });
      
      if (response.ok) {
        setAutoRenew(newValue);
        // Вибрация только если не передан флаг skipHaptic
        if (!skipHaptic) {
          triggerHaptic();
        }
      } else {
        const error = await response.json();
        alert('Ошибка: ' + (error.error || 'Неизвестная ошибка'));
      }
    } catch (error) {
      console.error('Error toggling auto-renewal:', error);
      alert('Ошибка соединения с сервером');
    }
  };

  const handleRemoveCard = (payment_method_id, cardInfo) => {
    if (!user?.telegram_id) return;
    
    setConfirmDialog({
      title: 'Удаление карты',
      message: `Удалить карту ${cardInfo}?`,
      onConfirm: () => {
        setConfirmDialog(null);
        removeCard(payment_method_id);
      },
      onCancel: () => setConfirmDialog(null)
    });
  };

  const removeCard = async (payment_method_id) => {
    try {
      const response = await fetch('/api/user/remove-payment-method', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          telegram_id: user.telegram_id, 
          payment_method_id 
        })
      });
      
      if (response.ok) {
        // Обновляем список карт после удаления
        setPaymentMethods(prev => prev.filter(method => method.payment_method_id !== payment_method_id));
        triggerHaptic();
        
        // Если удалили последнюю карту, отключаем автопродление
        const remainingMethods = paymentMethods.filter(method => method.payment_method_id !== payment_method_id);
        if (remainingMethods.length === 0) {
          setAutoRenew(false);
        }
      } else {
        const error = await response.json();
        alert('Ошибка: ' + (error.error || 'Неизвестная ошибка'));
      }
    } catch (error) {
      console.error('Error removing payment method:', error);
      alert('Ошибка соединения с сервером');
    }
  };

  const hasCards = paymentMethods.length > 0;

  return (
    <div className="purchase-screen">
      <div className="purchase-body">
        <div className="profile-card-bg">
          <div className="purchase-header" style={{display: 'flex', alignItems: 'center', marginBottom: 18, color: '#fff', fontWeight: 700, fontSize: '1.2rem'}}>
            Оплата
          </div>
          
          {loading ? (
            <div style={{textAlign: 'center', padding: '24px 0'}}>
              <div className="nvpn-loader" style={{width:36,height:36,border:'4px solid #ea5022',borderTop:'4px solid #000',borderRadius:'50%',animation:'spin 1s linear infinite',margin:'0 auto'}} />
            </div>
          ) : (
            <>
              {!hasCards ? (
                <div style={{
                  background: 'rgba(24,28,32,0.68)',
                  borderRadius: 14,
                  padding: '24px 12px',
                  color: '#fff',
                  textAlign: 'center',
                  marginBottom: 18,
                  fontSize: '1.08rem',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 8
                }}>
                  <span style={{fontSize: '2.2em', opacity: 0.7, marginBottom: 6}}>📄</span>
                  У вас еще нет добавленных способов оплаты
                  <div style={{fontSize: '0.95em', opacity: 0.8, marginTop: 6}}>
                    Совершите первый платеж, чтобы добавить способ оплаты для автопродления
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{marginBottom: 16, color: '#ea5022', fontWeight: 600, fontSize: '1.1em'}}>
                    Сохраненные способы оплаты:
                  </div>
                  {paymentMethods.map((method, index) => (
                    <div key={method.id} style={{
                      background: 'rgba(24,28,32,0.68)',
                      borderRadius: 14,
                      padding: '16px 14px',
                      marginBottom: 12,
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      position: 'relative'
                    }}>
                      <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
                        <span style={{fontSize: '1.5em'}}>💳</span>
                        <div>
                          <div style={{fontWeight: 600, fontSize: '1.1em'}}>
                            {method.card_type} •••• {method.card_last4}
                          </div>
                          <div style={{fontSize: '0.9em', opacity: 0.7}}>
                            {method.card_expiry_month && method.card_expiry_year ? 
                              `${method.card_expiry_month}/${method.card_expiry_year}` : 
                              'Добавлена ' + new Date(method.added_at).toLocaleDateString('ru-RU')
                            }
                          </div>
                        </div>
                      </div>
                      <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                        <div style={{color: '#a8eec1', fontSize: '0.9em', fontWeight: 600}}>
                          Активна
                        </div>
                        <button
                          onClick={() => { triggerHaptic(); handleRemoveCard(method.payment_method_id, `${method.card_type} •••• ${method.card_last4}`); }}
                          style={{
                            background: 'rgba(255,255,255,0.1)',
                            border: 'none',
                            borderRadius: '50%',
                            width: 28,
                            height: 28,
                            color: '#ff6b6b',
                            fontSize: '1.2em',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            opacity: 0.7
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = 'rgba(255,107,107,0.2)';
                            e.target.style.opacity = '1';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = 'rgba(255,255,255,0.1)';
                            e.target.style.opacity = '0.7';
                          }}
                                                 >
                           ×
                         </button>
                       </div>
                    </div>
                  ))}
                </div>
              )}
              
              <button 
                className="profile-list-btn" 
                style={{
                  marginBottom: 0, 
                  marginTop: 8,
                  opacity: hasCards ? 1 : 0.6,
                  cursor: hasCards ? 'pointer' : 'not-allowed'
                }}
                onClick={hasCards ? handleAutoRenewToggle : undefined}
                disabled={!hasCards}
              >
                {autoRenew ? 'Отключить автопродление' : 'Включить автопродление'}
              </button>
              
              {!hasCards && (
                <div style={{
                  fontSize: '0.9em',
                  color: '#ea5022',
                  opacity: 0.7,
                  textAlign: 'center',
                  marginTop: 8
                }}>
                  Автопродление будет доступно после первого платежа
                </div>
              )}
            </>
          )}
        </div>
      </div>
      
      {/* Кастомное модальное окно подтверждения */}
      {confirmDialog && (
        <ConfirmDialog
          title={confirmDialog.title}
          message={confirmDialog.message}
          confirmText={confirmDialog.confirmText}
          noConfirmHaptic={confirmDialog.noConfirmHaptic}
          onConfirm={confirmDialog.onConfirm}
          onCancel={confirmDialog.onCancel}
        />
      )}
    </div>
  );
}

function TransactionsModal({ user, onClose }) {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Загружаем транзакции пользователя
  useEffect(() => {
    const fetchTransactions = async () => {
      if (!user?.telegram_id) {
        setLoading(false);
        return;
      }

      try {
        const API_URL = window.location.hostname.includes('nitroovpn.ru')
          ? 'https://nitroovpn.ru'
          : '';
        
        const response = await fetch(`${API_URL}/api/user/transactions`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ telegram_id: user.telegram_id, limit: 50 })
        });
        
        if (response.ok) {
          const data = await response.json();
          setTransactions(data.transactions || []);
        } else {
          console.error('Failed to fetch transactions:', response.status);
          setError('Ошибка загрузки транзакций');
        }
      } catch (error) {
        console.error('Error fetching transactions:', error);
        setError('Ошибка сети');
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [user?.telegram_id]);

  // Функция для получения иконки типа операции
  const getOperationIcon = (type) => {
    switch (type) {
      case 'Подписка': return '📱';
      case 'Апгрейд устройств': return '📊';
      default: return '💳';
    }
  };

  // Функция для получения цвета типа операции
  const getOperationColor = (type) => {
    switch (type) {
      case 'Подписка': return '#a8eec1';
      case 'Апгрейд устройств': return '#ff9800';
      default: return '#ffe082';
    }
  };

  return (
    <div className="nvpn-center" style={{zIndex: 1000, pointerEvents: 'auto'}}>
      <div className="nvpn-card" style={{maxWidth: 420, width: '100%', margin: 0, padding: 0, borderRadius: '22px 22px 18px 18px'}}>
        <button className="modal-close" style={{position:'absolute',top:10,right:16}} onClick={() => { triggerHaptic(); onClose(); }}>&times;</button>
        <div style={{padding: '32px 24px 24px 24px', maxHeight: 420, overflowY: 'auto'}}>
          <div className="modal-header" style={{color:'#fff', fontWeight:700, marginBottom:18}}>Мои транзакции</div>
          
          {loading ? (
            <div style={{textAlign: 'center', padding: '40px 0'}}>
              <Loader />
              <div style={{color:'#ea5022', marginTop: 12}}>Загружаем транзакции...</div>
            </div>
          ) : error ? (
            <div style={{color:'#ff6b6b', textAlign:'center', padding: '20px 0'}}>
              <div style={{fontSize: '2em', marginBottom: 8}}>❌</div>
              <div>{error}</div>
            </div>
          ) : transactions.length === 0 ? (
            <div style={{color:'#ea5022', textAlign:'center', padding: '40px 0'}}>
              <div style={{fontSize: '3em', marginBottom: 12}}>🛒</div>
              <div style={{fontSize: '1.1em', fontWeight: 500}}>Нет транзакций</div>
              <div style={{fontSize: '0.95em', opacity: 0.7, marginTop: 4}}>Здесь будут отображаться ваши покупки</div>
            </div>
          ) : (
            <div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
              {transactions.map((tx, idx) => (
                <div key={tx.id || idx} style={{
                  background:'#23262b',
                  borderRadius:14,
                  padding:'16px 14px',
                  border: '1px solid rgba(255,255,255,0.05)',
                  transition: 'all 0.2s ease'
                }}>
                  {/* Заголовок транзакции с иконкой */}
                  <div style={{
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'space-between',
                    marginBottom:8
                  }}>
                    <div style={{display:'flex', alignItems:'center', gap:8}}>
                      <span style={{fontSize:'1.2em'}}>{getOperationIcon(tx.type)}</span>
                      <span style={{
                        color: getOperationColor(tx.type),
                        fontWeight:600,
                        fontSize:'0.95em'
                      }}>
                        {tx.type}
                      </span>
                    </div>
                    <span style={{
                      color:'#fff',
                      fontSize:'1.1em',
                      fontWeight:700
                    }}>
                      {tx.amount} ₽
                    </span>
                  </div>

                  {/* Описание услуги */}
                  <div style={{
                    color:'#fff',
                    fontWeight:500,
                    fontSize:'1em',
                    marginBottom:6
                  }}>
                    {tx.description}
                  </div>

                  {/* Дата и ссылка на чек */}
                  <div style={{
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'space-between',
                    marginTop:8
                  }}>
                    <span style={{
                      color:'#ea5022',
                      fontSize:'0.92em',
                      opacity:0.9
                    }}>
                      {tx.date}
                    </span>
                    
                    {tx.receipt_url ? (
                      <a 
                        href={tx.receipt_url} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{
                          color:'#a8eec1',
                          textDecoration:'none',
                          fontSize:'0.95em',
                          fontWeight:600,
                          padding: '4px 8px',
                          borderRadius: 6,
                          background: 'rgba(168, 238, 193, 0.1)',
                          border: '1px solid rgba(168, 238, 193, 0.2)',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => triggerHaptic()}
                        onMouseOver={e => e.target.style.background = 'rgba(168, 238, 193, 0.15)'}
                        onMouseOut={e => e.target.style.background = 'rgba(168, 238, 193, 0.1)'}
                      >
                        📄 Чек
                      </a>
                    ) : (
                      <span style={{
                        color:'#666',
                        fontSize:'0.9em',
                        fontStyle:'italic'
                      }}>
                        Чек недоступен
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function ReferralModal({ user, onClose }) {
  const [referralData, setReferralData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copyActive, setCopyActive] = useState(false);
  
  // Загружаем данные реферальной программы
  useEffect(() => {
    const fetchReferralData = async () => {
      try {
        const API_URL = window.location.hostname.includes('nitroovpn.ru')
          ? 'https://nitroovpn.ru'
          : '';
        
        const response = await fetch(`${API_URL}/api/referral/info`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ telegram_id: user.telegram_id })
        });
        
        if (response.ok) {
          const data = await response.json();
          setReferralData(data);
        } else {
          console.error('Failed to fetch referral data:', response.status);
        }
      } catch (error) {
        console.error('Error fetching referral data:', error);
      } finally {
        setLoading(false);
      }
    };
    
    if (user?.telegram_id) {
      fetchReferralData();
    }
  }, [user?.telegram_id]);
  
  const handleCopyReferral = () => {
    const linkToCopy = referralData?.referral_link || `https://t.me/NitrooVPNbot/app?startapp=ref${user.telegram_id}`;
    navigator.clipboard.writeText(linkToCopy);
    setCopyActive(true);
    setTimeout(() => setCopyActive(false), 1000);
  };
  
  if (loading) {
    return (
      <div className="nvpn-center" style={{zIndex: 1000, pointerEvents: 'auto'}}>
        <div className="nvpn-card" style={{maxWidth: 420, width: '100%', margin: 0, padding: 0, borderRadius: '22px 22px 18px 18px'}}>
          <div style={{padding: '64px 24px', textAlign: 'center', color: '#ea5022'}}>
            Загружаем данные...
          </div>
        </div>
      </div>
    );
  }
  
  const accruals = referralData?.recent_accruals || [];
  const stats = referralData?.stats || { total_invited: 0, total_accrued_days: 0 };
  const referralLink = referralData?.referral_link || `https://t.me/NitrooVPNbot/app?startapp=ref${user.telegram_id}`;
  return (
    <div className="nvpn-center" style={{zIndex: 1000, pointerEvents: 'auto'}}>
      <div className="nvpn-card" style={{maxWidth: 420, width: '100%', margin: 0, padding: 0, borderRadius: '22px 22px 18px 18px'}}>
        <button className="modal-close" style={{position:'absolute',top:10,right:16}} onClick={() => { triggerHaptic(); onClose(); }}>&times;</button>
        <div style={{padding: '32px 24px 24px 24px', maxHeight: '80vh', overflowY: 'auto'}}>
          <div className="modal-header" style={{color:'#fff', fontWeight:700, marginBottom:18}}>Реферальная программа</div>
          <div style={{background:'#23262b',borderRadius:14,padding:'18px 14px',marginBottom:14,color:'#fff',fontSize:'1.05em'}}>
            <b>🎁 6 дней</b> за каждого приглашённого друга<br/>
            <b>40% бонусных дней</b> от всех его покупок<br/>
            Например: друг купил 1 год → вы получите <b>146 дней</b><br/>
            <hr style={{border:'none',borderTop:'1px solid #333',margin:'12px 0'}}/>
            Приглашено друзей: <b>{stats.total_invited}</b><br/>
            Дней получено: <b>{stats.total_accrued_days}</b>
          </div>
          <div style={{marginBottom:10,color:'#ea5022'}}>Ваша реферальная ссылка:</div>
          <div style={{display:'flex',alignItems:'center',marginBottom:18}}>
            <input value={referralLink} readOnly style={{flex:1,background:'#181c20',color:'#fff',border:'1px solid #333',borderRadius:8,padding:'8px 10px',fontSize:'1em'}} />
            <button
              onClick={() => { triggerHaptic(); handleCopyReferral(); }}
              style={{
                marginLeft:8,
                background: copyActive ? '#d4451e' : '#ea5022',
                border:'none',
                borderRadius:12,
                padding:'12px 14px',
                cursor:'pointer',
                transition:'background 0.18s',
                display:'flex',
                alignItems:'center',
                justifyContent:'center',
                boxShadow: copyActive ? '0 2px 8px rgba(212, 69, 30, 0.4)' : undefined,
                outline: 'none'
              }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ background: 'none', outline: 'none' }}>
                <rect x="7" y="7" width="10" height="10" rx="3" stroke="#181c20" strokeWidth="2" fill="none"/>
                <rect x="3" y="3" width="10" height="10" rx="3" stroke="#181c20" strokeWidth="2" fill="none"/>
              </svg>
            </button>
          </div>
          <div style={{marginBottom:8,fontWeight:600,color:'#ea5022'}}>История начислений:</div>
          {accruals.length === 0 ? (
            <div style={{textAlign:'center',color:'#ea5022',opacity:0.7}}><span style={{fontSize:'2em'}}>📁</span><br/>Еще нет записей</div>
          ) : (
            <div>
              {accruals.map((a,i) => (
                <div key={i} style={{background:'#23262b',borderRadius:10,padding:'10px 8px',marginBottom:8,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <div>
                    <div style={{color:'#fff',fontWeight:500}}>{a.type}</div>
                    <div style={{color:'#ea5022',fontSize:'0.98em'}}>{a.date} — {a.friend}</div>
                  </div>
                  <div style={{color:'#ea5022',fontWeight:700,fontSize:'1.1em'}}>+{a.days} дн.</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function UserAgreementModal({ onClose }) {
  return (
    <div className="nvpn-center" style={{zIndex: 1000, pointerEvents: 'auto'}}>
      <div className="nvpn-card" style={{maxWidth: 480, width: '100%', margin: 0, padding: 0, borderRadius: '22px 22px 18px 18px'}}>
        <button className="modal-close" style={{position:'absolute',top:10,right:16}} onClick={() => { triggerHaptic(); onClose(); }}>&times;</button>
        <div style={{padding: '32px 24px 24px 24px', maxHeight: 520, overflowY: 'auto'}}>
          <div className="modal-header" style={{color:'#fff', fontWeight:700, marginBottom:18}}>Пользовательское соглашение</div>
          <div style={{color:'#fff', fontSize:'1.08em', lineHeight:1.6}}>
            <b>1. Общие положения</b><br/>
            Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует порядок использования сервиса NitrooVPN (далее — «Сервис»).<br/>
            Используя Сервис, вы подтверждаете, что ознакомились и согласны с условиями настоящего Соглашения.<br/><br/>
            <b>2. Условия использования</b><br/>
            Вы обязуетесь не использовать Сервис для целей, нарушающих законодательство Российской Федерации или других государств.<br/>
            Вы самостоятельно несете ответственность за любые действия, совершаемые с использованием Сервиса.<br/><br/>
            <b>3. Описание Сервиса</b><br/>
            Сервис обеспечивает конфиденциальность соединения в интернете, шифруя передаваемые данные и скрывая IP-адрес пользователя.<br/>
            Мы не предоставляем доступ к определённым ресурсам и не гарантируем доступ к каким-либо сторонним платформам.<br/>
            Сервис работает по принципу "облачной анонимизации", не отслеживает активность пользователей и не вмешивается в содержимое их интернет-трафика.<br/><br/>
            <b>4. Демо-период</b><br/>
            Новый пользователь получает доступ к бесплатному демо-периоду сроком на 3 дня с момента первого входа в приложение или авторизации.<br/><br/>
            <b>5. Подписка и автоматическое продление</b><br/>
            Пользователь соглашается на автоматическое продление подписки, если не отключил эту функцию вручную в разделе "Профиль → Оплата".<br/><br/>
            <b>6. Изменение стоимости подписки</b><br/>
            Мы оставляем за собой право изменять стоимость подписки.<br/>
            В случае повышения стоимости более чем на 10% вы будете уведомлены заранее.<br/>
            Изменения вступают в силу со следующего платёжного периода.<br/><br/>
            <b>7. Политика возврата</b><br/>
            Условия возврата: Вы можете запросить возврат средств, если полученные услуги были некачественными или не предоставлены в соответствии с условиями.<br/>
            Процедура возврата: Для запроса возврата свяжитесь с нашей службой поддержки по указанным контактным данным. Мы рассмотрим ваш запрос и произведем возврат средств.<br/>
            Сроки возврата: Мы рассмотрим ваш запрос в течение дня. Срок исполнения возврата зависит от вашего банка.<br/><br/>
            <b>8. Конфиденциальность</b><br/>
            Мы не собираем и не храним информацию о вашей онлайн-активности.<br/>
            Мы не передаём данные третьим лицам.<br/>
            Используются современные методы шифрования для защиты информации.<br/><br/>
            <b>9. Отказ от ответственности</b><br/>
            Сервис предоставляется «как есть» и «по мере доступности». Мы не гарантируем его бесперебойную, безошибочную или постоянную работу.<br/>
            Сервис не предназначен для обхода ограничений, блокировок или доступа к запрещённым ресурсам. Мы не контролируем, как пользователь использует соединение.<br/>
            Пользователь несёт полную ответственность за использование сервиса и соблюдение применимого законодательства.<br/>
            Мы не несем ответственности за любые действия, совершённые пользователями с использованием нашего сервиса.<br/><br/>
            <b>10. Заключительные положения</b><br/>
            Мы оставляем за собой право вносить изменения в настоящее Соглашение. Продолжение использования Сервиса после изменений означает согласие с ними.
          </div>
        </div>
      </div>
    </div>
  );
}

function LoaderScreen() {
  return (
    <div style={{height:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',position:'relative',backgroundColor:'#020202'}}>
      {/* Анимированный Silk фон */}
      <Silk 
        speed={5}
        scale={1}
        color="#1a1e23"
        noiseIntensity={1.5}
        rotation={0}
      />
      <div className="nvpn-loader" style={{width:36,height:36,border:'4px solid #ea5022',borderTop:'4px solid #000',borderRadius:'50%',animation:'spin 1s linear infinite',zIndex:1}} />
      <style>{`@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}`}</style>
    </div>
  );
}

// Функция для расчёта апгрейда и скидки
function getUpgradeOptions(currentDevices, selectedTariffIdx) {
  // Возвращает массив вариантов апгрейда: [{toDevices, upgradePrice, oldPrice, newPrice, discountPercent}]
  const options = [];
  for (let toDevices = currentDevices + 1; toDevices <= 5; toDevices++) {
    const oldPrice = TARIFFS[selectedTariffIdx].price[currentDevices-1];
    const newPrice = TARIFFS[selectedTariffIdx].price[toDevices-1];
    const upgradePrice = newPrice - oldPrice;
    const discountPercent = ((oldPrice + upgradePrice - newPrice) / newPrice) * 100;
    options.push({
      toDevices,
      upgradePrice,
      oldPrice,
      newPrice,
      discountPercent: ((1 - (upgradePrice + oldPrice) / newPrice) * 100).toFixed(2)
    });
  }
  return options;
}

function calculateUpgradePriceDiscount(currentTariffIdx, currentDevices, targetDevices) {
  // Цена апгрейда = (разница между тарифами) * 0.8 (20% скидка на разницу)
  const currentPrice = TARIFFS[currentTariffIdx].price[currentDevices - 1];
  const targetPrice = TARIFFS[currentTariffIdx].price[targetDevices - 1];
  const diff = targetPrice - currentPrice;
  return Math.round(diff * 0.8);
}

// Функция для определения активного тарифа по дате окончания подписки
function getActiveTariffInfo(user) {
  if (!user || !user.sub_end || user.tariff === 'trial') {
    return { tariffIndex: -1, devices: 1 };
  }

  const subEndDate = new Date(user.sub_end);
  const currentDate = new Date();
  const daysLeft = Math.ceil((subEndDate - currentDate) / (1000 * 60 * 60 * 24));
  
  // Если подписка истекла, возвращаем ошибку
  if (daysLeft <= 0) {
    return { tariffIndex: -1, devices: 1 };
  }

  // Получаем количество устройств из текущего тарифа
  const devices = parseInt(user.tariff.match(/(\d+)devices$/)?.[1] || '1', 10);

  // Определяем тариф по ближайшему соответствию к стандартным периодам
  const tariffDays = [30, 90, 180, 365]; // дни для каждого тарифа
  let tariffIndex = 0;
  let minDifference = Math.abs(daysLeft - tariffDays[0]);

  // Находим тариф с минимальной разницей в днях
  for (let i = 1; i < tariffDays.length; i++) {
    const difference = Math.abs(daysLeft - tariffDays[i]);
    if (difference < minDifference) {
      minDifference = difference;
      tariffIndex = i;
    }
  }

  console.log('==> ACTIVE TARIFF INFO:', {
    daysLeft,
    devices,
    tariffIndex,
    tariffName: TARIFFS[tariffIndex]?.label,
    userTariff: user.tariff,
    logic: `${daysLeft} дней → ближайший ${tariffDays[tariffIndex]} дней (${TARIFFS[tariffIndex]?.label})`
  });

  return { tariffIndex, devices };
}

function UpgradeDevicesModal({ user, onClose, setUser, onReturnToMain }) {
  // Все хуки должны быть в начале компонента
  const [targetDevices, setTargetDevices] = useState(1);
  const [showPaymentFlow, setShowPaymentFlow] = useState(false);

  // Используем правильное определение активного тарифа
  const activeTariffInfo = getActiveTariffInfo(user);
  const currentTariffIdx = activeTariffInfo.tariffIndex;
  const currentDevices = activeTariffInfo.devices;
  
  console.log('==> UpgradeDevicesModal render:', { showPaymentFlow, currentDevices, targetDevices });
  
  // Инициализируем targetDevices после получения currentDevices
  useEffect(() => {
    if (currentDevices > 0) {
      setTargetDevices(currentDevices); // Устанавливаем текущее значение по умолчанию
    }
  }, [currentDevices]);

  // Ранний возврат только после всех хуков
  if (currentTariffIdx === -1) return null;
  const isMax = currentDevices >= 5;

  const handleConfirmClick = () => {
    console.log('==> Opening payment flow');
    triggerHaptic();
    setShowPaymentFlow(true);
  };

  const handlePaymentFlowClose = () => {
    console.log('==> Closing payment flow');
    setShowPaymentFlow(false);
  };

  const handlePaymentSuccess = () => {
    console.log('==> Payment successful, closing all modals');
    setShowPaymentFlow(false);
    onClose();
    // Возвращаемся на главный экран, если функция передана
    if (onReturnToMain) {
      onReturnToMain();
    }
    // Показываем конфетти после закрытия модальных окон
    setTimeout(() => {
      showConfetti();
    }, 100);
  };

  // Если у пользователя максимальное количество устройств, показываем специальное модальное окно
  if (isMax) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        zIndex: 1001,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div className="nvpn-card" style={{
          maxWidth: 420, 
          width: '100%', 
          margin: 0, 
          padding: 0, 
          borderRadius: '22px 22px 18px 18px',
          position: 'relative'
        }}>
          <button className="modal-close" style={{position:'absolute',top:10,right:16}} onClick={() => { triggerHaptic(); onClose(); }}>&times;</button>
          <div style={{padding: '32px 24px 24px 24px', textAlign:'center'}}>
            <div className="modal-header" style={{color:'#fff', fontWeight:700, marginBottom:12}}>Добавление устройств</div>
            <div style={{marginBottom:12, color:'#ea5022'}}>Подписка до: <b>{new Date(user.sub_end).toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' })}</b></div>
            <div style={{marginBottom:12, color:'#ea5022'}}>Текущее количество устройств: <b>{pluralizeDevice(currentDevices)}</b></div>
            <div style={{margin:'32px 0',textAlign:'center',color:'#ea5022',fontWeight:600,fontSize:'1.08em'}}>У вас максимальное количество устройств</div>
          </div>
        </div>
      </div>
    );
  }

  // Показываем основное модальное окно снизу
  const currentPrice = TARIFFS[currentTariffIdx].price[currentDevices - 1];
  const targetPrice = TARIFFS[currentTariffIdx].price[targetDevices - 1];
  const upgradePrice = targetPrice - currentPrice;

  return (
    <>
      {/* Основное модальное окно снизу */}
      <div className="upgrade-sheet-overlay" onClick={onClose} aria-modal="true" role="dialog">
        <div className="upgrade-bottom-sheet" style={{minHeight:'38vh',maxWidth:440,width:'96vw',borderRadius:32,marginBottom:'2vh'}} onClick={e => e.stopPropagation()}>
          <button className="modal-close" style={{position:'absolute',top:10,right:16}} onClick={() => { triggerHaptic(); onClose(); }}>&times;</button>
          <div style={{fontWeight:700,fontSize:'1.15em',marginBottom:12,color:'#fff'}}>Добавление устройств</div>
          <div style={{marginBottom:12,color:'#ea5022'}}>Подписка до: <b>{new Date(user.sub_end).toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' })}</b></div>
          <div style={{marginBottom:12,color:'#ea5022'}}>Текущее количество устройств: <b>{pluralizeDevice(currentDevices)}</b></div>
          <div style={{marginBottom:18}}>
            <input type="range" min={currentDevices} max={5} value={Math.max(targetDevices, currentDevices)} onChange={e => { triggerHaptic(); setTargetDevices(Number(e.target.value)); }} className="purchase-slider-range" />
            <div className="purchase-slider-labels">
              {Array.from({length: 5-currentDevices+1}, (_,i) => currentDevices+i).map(val => (
                <span key={val} className={val === Math.max(targetDevices, currentDevices) ? 'active' : ''}>{val}</span>
              ))}
            </div>
          </div>
          <div style={{marginBottom:12,color:'#ea5022'}}>
            Подписка расширится до <b>{pluralizeDeviceGenitive(targetDevices)}</b>
          </div>
          <button 
            className="nvpn-btn nvpn-btn-orange-payment" 
            style={{width:'100%',fontWeight:700}} 
            onClick={handleConfirmClick}
            disabled={targetDevices <= currentDevices}
          >
            {targetDevices <= currentDevices ? 'Выберите больше устройств' : `Оплатить ${upgradePrice} ₽`}
          </button>
        </div>
      </div>

      {/* Отдельный компонент для потока оплаты */}
      {showPaymentFlow && (
        <UpgradePaymentFlow 
          user={user}
          currentDevices={currentDevices}
          targetDevices={targetDevices}
          currentTariffIdx={currentTariffIdx}
          onClose={handlePaymentFlowClose}
          onSuccess={handlePaymentSuccess}
          setUser={setUser}
          onReturnToMain={onReturnToMain}
        />
      )}
    </>
  );
}

// Отдельный компонент для потока оплаты
function UpgradePaymentFlow({ user, currentDevices, targetDevices, currentTariffIdx, onClose, onSuccess, setUser, onReturnToMain }) {
  const [modalStep, setModalStep] = useState('confirm'); // 'confirm' | 'method' | 'waiting' | 'success'
  const [payMethod, setPayMethod] = useState('bank_card');
  const [loading, setLoading] = useState(false);
  const [payUrl, setPayUrl] = useState('');
  const [paymentId, setPaymentId] = useState('');
  const [successSubEnd, setSuccessSubEnd] = useState(null); // <--- добавлено состояние
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState(null);
  const [errorModal, setErrorModal] = useState(null);

  console.log('==> UpgradePaymentFlow render:', { modalStep });

  // Автоматическая проверка статуса платежа
  useEffect(() => {
    let intervalId;
    
    if (modalStep === 'waiting' && paymentId && user?.telegram_id) {
      console.log('==> Starting device upgrade payment polling for:', paymentId);
      intervalId = setInterval(async () => {
        try {
          const res = await fetch('/api/payment/status', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ payment_id: paymentId, telegram_id: user.telegram_id })
          });
          
          if (!res.ok) return;
          
          const data = await res.json();
          console.log('==> Device upgrade payment status:', data);
          
          if (data.status === 'succeeded') {
            console.log('==> Device upgrade payment succeeded!');
            clearInterval(intervalId);
            setModalStep('success');
            // ... обновление пользователя ...
            setTimeout(async () => {
              try {
                const userRes = await fetch('/api/user/init', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(buildUserInitBody())
                });
                if (userRes.ok) {
                  const userData = await userRes.json();
                  console.log('==> Updated user data after device upgrade:', userData);
                  setUser(userData);
                  setSuccessSubEnd(userData.sub_end); // <-- теперь дата берётся из обновлённого пользователя
                }
              } catch (userError) {}
            }, 1500);
            showConfetti();
          }
        } catch (error) {
          console.error('==> Error checking device upgrade payment status:', error);
        }
      }, 2000);
    }
    return () => { if (intervalId) clearInterval(intervalId); };
  }, [modalStep, paymentId, user?.telegram_id, setUser]);

  useEffect(() => {
    if ((modalStep === 'method' || modalStep === 'confirm') && user?.telegram_id) {
      fetch('/api/user/payment-methods', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ telegram_id: user.telegram_id })
      })
        .then(res => res.json())
        .then(data => setPaymentMethods(data.payment_methods || []))
        .catch(() => setPaymentMethods([]));
    }
  }, [modalStep, user?.telegram_id]);

  const handlePay = async () => {
    setLoading(true);
    
    // Рассчитываем цену апгрейда
    const currentPrice = TARIFFS[currentTariffIdx].price[currentDevices - 1];
    const targetPrice = TARIFFS[currentTariffIdx].price[targetDevices - 1];
    const upgradePrice = targetPrice - currentPrice;
    
    const amount = upgradePrice.toFixed(2);
    let description;
    if (payMethod === 'saved_card' && selectedPaymentMethodId) {
      description = `Ручной автоплатёж: Добавление устройств, устройств: ${targetDevices}`;
    } else {
      description = `Добавление устройств: ${targetDevices}`;
    }

    if (payMethod === 'saved_card' && selectedPaymentMethodId) {
      try {
        const res = await fetch('/api/yookassa/pay-with-saved-card', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            telegram_id: user.telegram_id,
            amount,
            description,
            payment_method_id: selectedPaymentMethodId
          })
        });
        const data = await res.json();
        if (data.status === 'succeeded') {
          // Платеж создан успешно, webhook обработает его
          setModalStep('waiting');
          setPaymentId(data.payment_id);
          // Убираем немедленное обновление данных - webhook сделает это
        } else {
          setErrorModal('Платёж не прошёл. Попробуйте другой способ оплаты или обратитесь в поддержку.');
          setModalStep('error');
        }
      } catch (e) {
        setErrorModal('Платёж не прошёл. Попробуйте другой способ оплаты или обратитесь в поддержку.');
        setModalStep('error');
      } finally {
        setLoading(false);
      }
      return;
    }

    const API_URL = window.location.hostname.includes('nitroovpn.ru')
      ? 'https://nitroovpn.ru'
      : '';
    
    try {
      const res = await fetch(`${API_URL}/api/yookassa/create-device-upgrade-payment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount,
          devices: targetDevices,
          telegram_id: user?.telegram_id,
          method: payMethod,
          return_context: 'upgrade' // Контекст для возврата на экран апгрейда
        })
      });
      
      const data = await res.json();
      if (data.confirmation_url) {
        setPayUrl(data.confirmation_url);
        setPaymentId(data.payment_id);
        setModalStep('waiting');
      } else {
        alert('Ошибка создания платежа: ' + (data.error || 'Неизвестная ошибка'));
      }
    } catch (e) {
      alert('Ошибка соединения с сервером оплаты');
    } finally {
      setLoading(false);
    }
  };

  const currentPrice = TARIFFS[currentTariffIdx].price[currentDevices - 1];
  const targetPrice = TARIFFS[currentTariffIdx].price[targetDevices - 1];
  const upgradePrice = targetPrice - currentPrice;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      zIndex: 1002, // Выше основного модального окна
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div className="nvpn-card" style={{
        maxWidth: 420, 
        width: '100%', 
        margin: 0, 
        padding: 0, 
        borderRadius: '22px 22px 18px 18px',
        position: 'relative'
      }}>
        <button className="modal-close" style={{position:'absolute',top:10,right:16}} onClick={() => { triggerHaptic(); onClose(); }}>&times;</button>
        
        {modalStep === 'confirm' && (
          <div style={{padding: '32px 24px 24px 24px'}}>
                          <div className="modal-header" style={{color:'#fff', fontWeight:700}}>Подтверждение</div>
            <div className="modal-body" style={{color:'#ea5022'}}>
              <div style={{marginBottom:12}}>Подписка до: <b>{new Date(user.sub_end).toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' })}</b></div>
              <div style={{marginBottom:12}}>Количество устройств: <b>{targetDevices}</b></div>
              <div className="confirm-pay-row" style={{display:'flex',alignItems:'center',marginBottom:18,background:'#23262b',borderRadius:12,padding:'0 8px',gap:8}}>
                <span style={{fontSize:'1.3em',color:'#ea5022',padding:'0 8px'}}>+</span>
                <span style={{flex:1, fontWeight:500, color:'#fff',fontSize:'1.08em',padding:'14px 0'}}>
                  {payMethod === 'sbp'
                    ? 'Оплата новым счётом СБП'
                    : payMethod === 'saved_card' && selectedPaymentMethodId
                      ? (() => {
                          const card = paymentMethods.find(m => m.payment_method_id === selectedPaymentMethodId);
                          return card
                            ? `Оплата сохранённой картой ${card.card_type} •••• ${card.card_last4}`
                            : 'Оплата сохранённой картой';
                        })()
                      : 'Оплата новой картой'
                  }
                </span>
                <button className="change-method-btn" style={{background:'none',border:'none',color:'#ea5022',fontWeight:600,fontSize:'1.1em',display:'flex',alignItems:'center',cursor:'pointer',padding:'0 8px'}} onClick={(e) => { e.stopPropagation(); triggerHaptic(); setModalStep('method'); }}>
                  Изменить <span style={{fontSize:'1.2em',marginLeft:4}}>&#8250;</span>
                </button>
              </div>
              <button className="nvpn-btn nvpn-btn-orange-payment confirm-btn" style={{width:'100%', fontSize:'0.98rem', padding:'13px 0', animation: loading ? 'none' : 'shine 2s ease-in-out infinite'}} onClick={(e) => { e.stopPropagation(); triggerHaptic(); handlePay(); }} disabled={loading}>
                {loading ? 'Создание оплаты...' : `Оплатить ${upgradePrice} ₽`}
              </button>
            </div>
          </div>
        )}

        {modalStep === 'method' && (
          <div style={{padding: '32px 24px 24px 24px'}}>
            <div className="modal-header payment-method" style={{color:'#ea5022'}}>
              <span className="back-arrow" style={{color:'#ea5022'}} onClick={(e) => { e.stopPropagation(); triggerHaptic(); setModalStep('confirm'); }}>&larr;</span>
              Изменить способ оплаты
            </div>
            <div className="modal-body">
              {paymentMethods.length > 0 && (
                <div style={{marginBottom: 16}}>
                  {paymentMethods.map(method => (
                    <button
                      key={method.payment_method_id}
                      className="nvpn-btn nvpn-btn-orange-payment"
                      style={{
                        marginBottom: 8,
                        border: selectedPaymentMethodId === method.payment_method_id ? '2px solid #ea5022' : undefined
                      }}
                      onClick={() => {
                        triggerHaptic();
                        setSelectedPaymentMethodId(method.payment_method_id);
                        setPayMethod('saved_card');
                        setModalStep('confirm');
                      }}
                    >
                      💳 {method.card_type} •••• {method.card_last4}
                    </button>
                  ))}
                </div>
              )}
              <button className="nvpn-btn nvpn-btn-orange-payment" style={{marginBottom:12}} onClick={(e) => { e.stopPropagation(); triggerHaptic(); setPayMethod('sbp'); setModalStep('confirm'); }}>
                <span role="img" aria-label="sbp">🏦</span> Оплата новым счётом <b>СБП</b>
              </button>
              <button className="nvpn-btn nvpn-btn-orange-payment" onClick={(e) => { e.stopPropagation(); triggerHaptic(); setPayMethod('bank_card'); setModalStep('confirm'); }}>
                <span role="img" aria-label="card">💳</span> Оплата новой картой
              </button>
            </div>
          </div>
        )}

        {modalStep === 'waiting' && (
          <div style={{padding: '32px 24px 24px 24px', textAlign:'center'}}>
            <div className="modal-body" style={{color:'#ea5022'}}>
              <div style={{marginBottom:12}}>
                Оплатите счёт в сервисе ЮKassa
              </div>
              <Loader />
              <button className="nvpn-btn nvpn-btn-orange-payment" style={{marginTop:12}} onClick={() => { if(window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.openLink) window.Telegram.WebApp.openLink(payUrl); else window.open(payUrl, '_blank'); }}>
                Перейти на форму оплаты
              </button>
            </div>
          </div>
        )}

        {modalStep === 'success' && (
          <div style={{
            padding: '32px 24px 24px 24px',
            textAlign: 'center',
            background: 'rgba(35,24,27,0.98)',
            borderRadius: 22,
            boxShadow: '0 8px 32px 0 rgba(0,0,0,0.22)',
            color: '#fff',
            maxWidth: 380,
            margin: '0 auto',
            position: 'relative',
          }}>
            <div style={{
              fontSize: '1.5em',
              fontWeight: 700,
              color: '#fff',
              marginBottom: 12,
              letterSpacing: 0.2,
              textShadow: '0 2px 8px rgba(0,0,0,0.10)'
            }}>Успешно оплачено</div>
            <div style={{color:'#fff', fontSize:'1.1em', marginBottom:18}}>
              Количество устройств увеличено до <b>{targetDevices}</b>
            </div>
            <div style={{margin:'24px 0'}}>
              <span style={{
                display:'inline-block',
                border:'2.5px solid #ea5022',
                borderRadius:'50%',
                width:64,
                height:64,
                margin:'0 auto',
                lineHeight:'64px',
                fontSize:'2.5em',
                color:'#fff',
                background:'#23181b',
                boxShadow:'0 2px 8px rgba(234,80,34,0.18)'
              }}>&#10003;</span>
            </div>
            <button className="nvpn-btn nvpn-btn-main" style={{
              width:'100%',
              fontSize:'1.1em',
              marginTop:8,
              background: 'linear-gradient(90deg,#ea5022,#d4451e)',
              color: '#fff',
              fontWeight: 700,
              border: 'none',
              borderRadius: 16,
              boxShadow: '0 4px 24px rgba(234,80,34,0.10)',
              padding: '14px 0',
              transition: 'none'
            }} onClick={() => { 
              triggerHaptic(); 
              setModalStep(null); 
              if (onSuccess) onSuccess();
              setTimeout(() => { showConfetti(); }, 100);
            }}>
              Вернуться на главную
            </button>
          </div>
        )}

        {modalStep === 'error' && (
          <div style={{padding: '32px 24px 24px 24px', textAlign:'center'}}>
            <div style={{fontSize: '1.5em', fontWeight: 700, color: '#ff6b6b', marginBottom: 12}}>Ошибка оплаты</div>
            <div style={{fontSize: '2.5em', color: '#ff6b6b', marginBottom: 18}}>❌</div>
            <div style={{color:'#fff', fontSize:'1.1em', marginBottom:18}}>{errorModal}</div>
            <button className="nvpn-btn nvpn-btn-main" style={{
              width:'100%',
              fontSize:'1.1em',
              marginTop:8,
              background: 'linear-gradient(90deg,#ea5022,#d4451e) !important',
              color: '#fff !important',
              fontWeight: 700,
              border: 'none !important',
              borderRadius: 16,
              boxShadow: '0 4px 24px rgba(234,80,34,0.10)',
              padding: '14px 0',
              transition: 'none !important',
              WebkitTransition: 'none !important',
              MozTransition: 'none !important'
            }} onClick={() => { triggerHaptic(); setErrorModal(null); setModalStep('method'); }}>
              Вернуться к выбору оплаты
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// Константы для ссылок на VPN клиенты
const VPN_CLIENTS = {
  Windows: {
    name: 'Happ',
    url: 'https://github.com/Happ-proxy/happ-desktop/releases/latest/download/setup-Happ.x64.exe'
  },
  macOS: {
    name: 'Happ',
    url: 'https://apps.apple.com/us/app/happ-proxy-utility/id6504287215', // Global по умолчанию
    urlRU: 'https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6788279553', // RU версия
    urlGlobal: 'https://apps.apple.com/us/app/happ-proxy-utility/id6504287215' // Global версия
  },
  Android: {
    name: 'Happ',
    url: 'https://play.google.com/store/apps/details?id=com.happproxy'
  },
  iOS: {
    name: 'Happ',
    url: 'https://apps.apple.com/us/app/happ-proxy-utility/id6504287215', // Global по умолчанию
    urlRU: 'https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6788279553', // RU версия
    urlGlobal: 'https://apps.apple.com/us/app/happ-proxy-utility/id6504287215' // Global версия
  }
};

// Схема диплинка Happ для импорта подписки
const HAPP_IMPORT_SCHEME = 'happ://add/';

function hasReadySubscriptionConfig(user) {
  if (!user) return false;

  const hasVpnKey = Boolean(user.vpn_key && user.vpn_key !== 'creating...' && user.vpn_key !== '—');
  const hasPrimaryConfig = Boolean(user.primary_subscription_config);
  const hasConfigCount = Number(user.subscription_config_count || 0) > 0;

  return hasVpnKey || hasPrimaryConfig || hasConfigCount;
}

function SetupScreen({ user, onBack, step, setStep }) {
  const [pulseIcon, setPulseIcon] = useState(false);
  const [prevStep, setPrevStep] = useState(null);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const platform = getPlatform();
  const client = VPN_CLIENTS[platform];

  // Отладочная информация для step
  useEffect(() => {
    console.log('==> SetupScreen step changed to:', step);
  }, [step]);

  // Кнопка назад теперь управляется из App.js (как в других экранах)
  // Для навигации между шагами добавим кнопки в UI

  const triggerIconPulse = () => {
    setPulseIcon(true);
    setTimeout(() => setPulseIcon(false), 600); // Длительность анимации
  };

  // Анимация иконки при изменении шага
  useEffect(() => {
    // Запускаем анимацию при любом изменении шага
    if (prevStep !== step) {
      const timer = setTimeout(() => {
        triggerIconPulse();
      }, prevStep === null ? 250 : 150); // Уменьшено время в 2 раза
      
      // Обновляем предыдущий шаг
      setPrevStep(step);
      
      return () => clearTimeout(timer);
    }
  }, [step]);

  const handleDownloadApp = () => {
    triggerHaptic();
    
    // Показываем модальное окно для всех платформ
    setShowDownloadModal(true);
  };

  const handleConfirmDownload = () => {
    triggerHaptic();
    setShowDownloadModal(false);
    
    // Переходим к скачиванию после подтверждения для платформ с одной кнопкой
    if (platform !== 'macOS' && platform !== 'iOS') {
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.openLink) {
        window.Telegram.WebApp.openLink(client.url);
      } else {
        window.open(client.url, '_blank');
      }
    }
  };

  const handleDownloadStoreVersion = (version) => {
    triggerHaptic();
    setShowDownloadModal(false);
    
    const url = version === 'ru' ? client.urlRU : client.urlGlobal;
    if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.openLink) {
      window.Telegram.WebApp.openLink(url);
    } else {
      window.open(url, '_blank');
    }
  };

  // Функция для открытия поста в Telegram канале
  const handleOtherDeviceSetup = () => {
    triggerHaptic();
    
    const tg = window.Telegram && window.Telegram.WebApp;
    
    if (tg) {
      console.log('==> Opening channel post for device setup');
      
      // Попытка 1: Прямое открытие поста через openTelegramLink
      if (typeof tg.openTelegramLink === 'function') {
        try {
          console.log('==> Trying openTelegramLink with direct post URL');
          tg.openTelegramLink('https://t.me/nitrooapp/32');
          
          // Закрываем приложение после успешного открытия
          if (typeof tg.close === 'function') {
            setTimeout(() => {
              console.log('==> Closing app after opening channel post');
              tg.close();
            }, 300);
          }
          return;
        } catch (error) {
          console.log('==> openTelegramLink failed:', error);
        }
      }
      
      // Попытка 2: Использование openLink (откроется в браузере, но потом закроем приложение)
      if (typeof tg.openLink === 'function') {
        try {
          console.log('==> Using openLink as fallback');
          tg.openLink('https://t.me/nitrooapp/32');
          
          // Закрываем приложение чтобы пользователь мог перейти в Telegram
          if (typeof tg.close === 'function') {
            setTimeout(() => {
              console.log('==> Closing app to help user switch to Telegram');
              tg.close();
            }, 1000);
          }
          return;
        } catch (error) {
          console.log('==> openLink failed:', error);
        }
      }
      
      // Fallback: обычная ссылка
      console.log('==> Using fallback method');
      window.open('https://t.me/nitrooapp/32', '_blank');
    } else {
      // Для браузера без Telegram WebApp
      window.open('https://t.me/nitrooapp/32', '_blank');
    }
  };

  const handleAddSubscription = async () => {
    const currentPlatform = getPlatform();
    console.log('==> handleAddSubscription called, platform:', currentPlatform);
    console.log('==> User Agent:', navigator.userAgent);
    console.log('==> Telegram Platform:', window.Telegram?.WebApp?.platform);
    
    // Проверяем наличие VPN ключа
    if (!hasReadySubscriptionConfig(user)) {
      alert('Конфиги подписки еще не готовы. Пожалуйста, подождите несколько секунд и попробуйте снова.');
      return;
    }
    
    triggerHaptic();
    
    // Для Windows и macOS копируем ссылку-подписку, для iOS/Android открываем приложения
    const isWindowsOrMac = currentPlatform === 'Windows' || currentPlatform === 'macOS';
    console.log('==> isWindowsOrMac:', isWindowsOrMac, 'currentPlatform:', currentPlatform);
    
    if (isWindowsOrMac) {
      try {
        const API_URL = window.location.hostname.includes('nitroovpn.ru') ? 'https://nitroovpn.ru' : '';
        const response = await fetch(`${API_URL}/api/config/create-short-link`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ telegram_id: user.telegram_id })
        });
        if (!response.ok) return;
        const { short_url } = await response.json();

        let deep;
        let redirect;
        if (currentPlatform === 'Windows') {
          // Happ на Windows
          deep = `${HAPP_IMPORT_SCHEME}${short_url}`;
          redirect = `${window.location.origin}/redirect-happ.html?h=${encodeURIComponent(deep)}`;
        } else {
          // Happ на macOS
          deep = `${HAPP_IMPORT_SCHEME}${short_url}`;
          redirect = `${window.location.origin}/redirect-happ.html?h=${encodeURIComponent(deep)}`;
        }

        if (window.Telegram?.WebApp?.openLink) {
          window.Telegram.WebApp.openLink(redirect);
        } else {
          window.location.href = redirect;
        }
      } catch (e) {
        console.error('==> Desktop deep link error:', e);
      }
    } else if (currentPlatform === 'iOS' && !isWindowsOrMac) {
      // Для iOS пробуем методы вызова диалогового окна с автоимпортом в Happ
      try {
        const API_URL = window.location.hostname.includes('nitroovpn.ru')
          ? 'https://nitroovpn.ru'
          : '';
        
        // Создаем короткую ссылку
        const response = await fetch(`${API_URL}/api/config/create-short-link`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ telegram_id: user.telegram_id })
        });
        
        if (response.ok) {
          const responseData = await response.json();
          const shortUrl = responseData.short_url;
          const happUrl = `${HAPP_IMPORT_SCHEME}${shortUrl}`;
          
          console.log(`==> Trying iOS methods to open Happ:`, happUrl);
          
          // Методы для iOS (работают лучше на iOS)
          const simulateClick = () => {
            const link = document.createElement('a');
            link.href = happUrl;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            
            ['click', 'mousedown', 'mouseup'].forEach(eventType => {
              const event = new MouseEvent(eventType, {
                bubbles: true,
                cancelable: true,
                view: window
              });
              link.dispatchEvent(event);
            });
            
            link.click();
            setTimeout(() => document.body.removeChild(link), 1000);
          };
          
          const tryLocationMethods = () => {
            try { window.top.location.href = happUrl; } catch(e) {}
            try { window.parent.location.href = happUrl; } catch(e) {}
            try { window.location.replace(happUrl); } catch(e) {}
            try { document.location.href = happUrl; } catch(e) {}
          };
          
          const tryTelegramMethods = () => {
            try {
              if (window.Telegram?.WebApp?.openLink) {
                window.Telegram.WebApp.openLink(happUrl);
              }
              if (window.Telegram?.WebApp?.openTelegramLink) {
                window.Telegram.WebApp.openTelegramLink(happUrl);
              }
            } catch(e) {
              console.log('Telegram methods failed:', e);
            }
          };
          
          // Запускаем методы для iOS
          setTimeout(tryLocationMethods, 0);
          setTimeout(simulateClick, 100);
          setTimeout(tryTelegramMethods, 200);
          
          // Также пробуем прямое присвоение
          window.location.href = happUrl;
          
          console.log(`==> All iOS Happ deep link methods attempted`);
        }
      } catch (error) {
        console.error(`==> Error creating iOS link:`, error);
      }
    } else if (currentPlatform === 'Android' && !isWindowsOrMac) {
      // Для Android: импорт подписки в Happ через редирект-страницу
      try {
        const API_URL = window.location.hostname.includes('nitroovpn.ru')
          ? 'https://nitroovpn.ru'
          : '';

        const response = await fetch(`${API_URL}/api/config/create-short-link`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ telegram_id: user.telegram_id })
        });

        if (!response.ok) return;
        const { short_url } = await response.json();

        const deep = `${HAPP_IMPORT_SCHEME}${short_url}`;
        const redirect = `${window.location.origin}/redirect-happ.html?h=${encodeURIComponent(deep)}`;

        if (window.Telegram?.WebApp?.openLink) {
          window.Telegram.WebApp.openLink(redirect);
        } else {
          window.location.href = redirect;
        }
      } catch (e) {
        console.error('==> Android deep link error:', e);
      }
    } else {
      // Для других платформ копируем ключ в буфер обмена без уведомлений
      console.log('==> Fallback: copying VPN key for platform:', currentPlatform);
      try {
        await navigator.clipboard.writeText(user.vpn_key);
        console.log('==> VPN key copied successfully (no notification)');
      } catch (error) {
        console.error('==> Failed to copy to clipboard:', error);
        // Не показываем alert, только логируем ошибку
      }
    }
  };

  const renderChoiceStep = () => (
    <div style={{ textAlign: 'center', padding: '60px 20px 40px' }}>
      <div style={{ marginBottom: 40 }}>
        <div style={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.15)',
          border: '3px solid rgba(255, 255, 255, 0.3)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 2px 8px rgba(255, 255, 255, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px',
          position: 'relative',
          backdropFilter: 'blur(10px)'
        }}>
          <span 
            className={pulseIcon ? 'icon-pulse' : ''}
            style={{ 
              fontSize: '3.5em',
              filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
            }}
          >🔌</span>
        </div>
      </div>

      {/* Убираем крупный заголовок, чтобы не мигал при переходе */}
      {/* <h1 style={{
        fontSize: '2.2em',
        fontWeight: 700,
        color: '#fff',
        marginBottom: 12,
        textShadow: '0 2px 8px rgba(0, 0, 0, 0.3), 0 0 16px rgba(255, 255, 255, 0.1)'
      }}>
        Настройка на {platform}
      </h1> */}

      <p style={{
        color: '#fff',
        fontSize: '1.2em',
        marginBottom: 40,
        opacity: 0.95,
        textShadow: '0 1px 4px rgba(0, 0, 0, 0.4)',
        maxWidth: '300px',
        margin: '0 auto 40px'
      }}>
        Настройка VPN происходит в 3 клика и занимает пару минут
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%', maxWidth: '320px', margin: '0 auto' }}>
        <button
          className="nvpn-btn nvpn-btn-orange-setup"
          style={{
            width: '100%',
            fontSize: '1.1em',
            padding: '16px 0',
            fontWeight: 700
          }}
          onClick={() => { triggerHaptic(); setStep('intro'); }}
        >
          Начать настройку на этом устройстве
        </button>
        
        <button
          className="nvpn-btn nvpn-btn-dark"
          style={{
            width: '100%',
            background: 'rgba(24,28,32,0.68)',
            color: '#fff',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            fontSize: '1.1em',
            padding: '16px 0',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
          }}
          onClick={handleOtherDeviceSetup}
        >
          Установить на другом устройстве
        </button>
      </div>
    </div>
  );

  const renderIntroStep = () => (
    <div style={{ textAlign: 'center', padding: '60px 20px 40px' }}>
      <div style={{ marginBottom: 40 }}>
        <div style={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.15)',
          border: '3px solid rgba(255, 255, 255, 0.3)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 2px 8px rgba(255, 255, 255, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px',
          position: 'relative',
          backdropFilter: 'blur(10px)'
        }}>
          <span 
            className={pulseIcon ? 'icon-pulse' : ''}
            style={{ 
              fontSize: '3.5em',
              filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
            }}
          >🔧</span>
        </div>
      </div>

      {/* <h1 style={{
        fontSize: '2.2em',
        fontWeight: 700,
        color: '#fff',
        marginBottom: 12,
        textShadow: '0 2px 8px rgba(0, 0, 0, 0.3), 0 0 16px rgba(255, 255, 255, 0.1)'
      }}>
        Настройка на {platform}
      </h1> */}

      <p style={{
        color: '#fff',
        fontSize: '1.2em',
        marginBottom: 40,
        opacity: 0.95,
        textShadow: '0 1px 4px rgba(0, 0, 0, 0.4)',
        maxWidth: '300px',
        margin: '0 auto 40px'
      }}>
        Установите приложение {client.name} и вернитесь к этому экрану
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%', maxWidth: '320px', margin: '0 auto' }}>
        <button
          className="nvpn-btn nvpn-btn-orange-setup"
          style={{
            width: '100%',
            fontSize: '1.1em',
            padding: '16px 0',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10
          }}
          onClick={handleDownloadApp}
        >
          <span>⬇️</span>
          Установить
        </button>

        <button
          className="nvpn-btn nvpn-btn-dark"
          style={{
            width: '100%',
            background: 'rgba(24,28,32,0.68)',
            color: '#fff',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            fontSize: '1.1em',
            padding: '16px 0',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10
          }}
          onClick={() => { 
            triggerHaptic(); 
            setStep('subscription');
          }}
        >
          <span>→</span>
          Далее
        </button>
      </div>
    </div>
  );



  const renderSubscriptionStep = () => {
    const currentPlatform = getPlatform();
    const isWindows = currentPlatform === 'Windows' || currentPlatform === 'macOS';
    
    return (
      <div style={{ textAlign: 'center', padding: '60px 20px 40px' }}>
        <div style={{ marginBottom: 40 }}>
          <div style={{
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'rgba(255, 193, 7, 0.25)',
            border: '3px solid #ffc107',
            boxShadow: '0 8px 32px rgba(255, 193, 7, 0.4), inset 0 2px 8px rgba(255, 255, 255, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 30px',
            position: 'relative'
          }}>
            <span 
              className={pulseIcon ? 'icon-pulse' : ''}
              style={{ 
                fontSize: '4em', 
                color: '#fff',
                fontWeight: 'bold',
                textShadow: '0 2px 8px rgba(0, 0, 0, 0.5)'
              }}
            >{'+'}</span>
          </div>
        </div>

        <h1 style={{
          fontSize: '2.2em',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 12,
          textShadow: '0 2px 8px rgba(0, 0, 0, 0.3), 0 0 16px rgba(255, 255, 255, 0.1)'
        }}>
          Подписка
        </h1>

        <p style={{
          color: '#fff',
          fontSize: '1.2em',
          marginBottom: 40,
          opacity: 0.95,
          textShadow: '0 1px 4px rgba(0, 0, 0, 0.4)',
          maxWidth: '300px',
          margin: '0 auto 40px'
        }}>
          {isWindows
            ? `Добавьте подписку в приложение ${client?.name || 'VPN-клиент'} с помощью кнопки ниже`
            : `Добавьте подписку в приложение ${client?.name || 'VPN-клиент'} с помощью кнопки ниже`}
        </p>



        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%', maxWidth: '320px', margin: '0 auto' }}>
                     <button
             className="nvpn-btn nvpn-btn-orange-setup"
             style={{
               width: '100%',
               fontSize: '1.1em',
               padding: '16px 0',
               fontWeight: 700,
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center',
               gap: 10
             }}
             onClick={() => {
               triggerHaptic();
               handleAddSubscription();
             }}
           >
             <>
               <span>➕</span>
               Добавить подписку
             </>
           </button>

          <button
          className="nvpn-btn nvpn-btn-dark"
          style={{
            width: '100%',
            background: 'rgba(24,28,32,0.68)',
            color: '#fff',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            fontSize: '1.1em',
            padding: '16px 0',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10
          }}
          onClick={() => { 
            triggerHaptic(); 
            setStep('success'); 
            showConfetti();
          }}
        >
          <span>→</span>
          Далее
        </button>
      </div>
    </div>
  ); // <-- Добавляем закрывающую скобку для функции renderSubscriptionStep
  };  // Закрывающая скобка для функции renderSubscriptionStep

  const renderSuccessStep = () => (
    <div style={{ textAlign: 'center', padding: '60px 20px 40px' }}>
      <div style={{ marginBottom: 40 }}>
        <div style={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #ff9100, #ff6f00)',
          boxShadow: '0 8px 32px rgba(255, 145, 0, 0.4), inset 0 2px 8px rgba(255, 255, 255, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px',
          position: 'relative'
        }}>
          <span 
            className={pulseIcon ? 'icon-pulse' : ''}
            style={{ 
              fontSize: '3.5em', 
              color: '#fff',
              filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
            }}
          >✓</span>
        </div>
      </div>

      <h1 style={{
        fontSize: '2.5em',
        fontWeight: 700,
        color: '#ff9100',
        marginBottom: 12,
        textShadow: '0 2px 8px rgba(255, 145, 0, 0.3)'
      }}>
        Готово!
      </h1>

      <p style={{
        color: '#fff',
        fontSize: '1.2em',
        marginBottom: 40,
        opacity: 0.95,
        textShadow: '0 1px 4px rgba(0, 0, 0, 0.4)',
        maxWidth: '300px',
        margin: '0 auto 40px'
      }}>
        Нажмите на круглую кнопку включения VPN в приложении {client?.name || 'VPN-клиент'}
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%', maxWidth: '320px', margin: '0 auto' }}>
        <button
          className="nvpn-btn nvpn-btn-orange-setup"
          style={{
            width: '100%',
            fontSize: '1.1em',
            padding: '16px 0',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10
          }}
          onClick={() => { 
            triggerHaptic(); 
            onBack(); 
          }}
        >
          <span>✓</span>
          Завершить настройку
        </button>
      </div>
    </div>
  );

  // Модальное окно с важной информацией для всех платформ
  const renderDownloadModal = () => {
    if (!showDownloadModal) return null;

    return (
      <div className="nvpn-center" style={{zIndex: 1000, pointerEvents: 'auto'}}>
        <div className="nvpn-card" style={{maxWidth: 420, width: '100%', margin: 0, padding: 0, borderRadius: '22px 22px 18px 18px'}}>
          <button 
            className="modal-close" 
            style={{position:'absolute',top:10,right:16, fontSize: '1.8em', background: 'none', border: 'none', color: '#fff', cursor: 'pointer'}} 
            onClick={() => { triggerHaptic(); setShowDownloadModal(false); }}
          >
            &times;
          </button>
          <div style={{padding: '32px 24px 24px 24px'}}>
            <div className="modal-header" style={{color:'#ffe082', fontWeight:700, fontSize: '1.2em', marginBottom: 20}}>
              Важная информация
            </div>
            <div className="modal-body" style={{color:'#fff', fontSize: '1.05em', lineHeight: '1.5', marginBottom: 24}}>
              После установки приложения {client?.name}, обязательно вернитесь на этот экран и нажмите «Далее», чтобы добавить конфигурацию в приложение, без этого VPN работать не будет
            </div>
            
            {/* Для iOS и macOS показываем две кнопки App Store */}
            {platform === 'macOS' || platform === 'iOS' ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <button 
                  className="nvpn-btn nvpn-btn-orange-setup" 
                  style={{
                    width:'100%',
                    fontSize:'1.1em',
                    borderRadius: '12px',
                    padding: '16px 0',
                    fontWeight: 700
                  }} 
                  onClick={() => handleDownloadStoreVersion('ru')}
                >
                  Скачать из RU App Store
                </button>
                <button 
                  className="nvpn-btn nvpn-btn-orange-setup" 
                  style={{
                    width:'100%',
                    fontSize:'1.1em',
                    background: 'linear-gradient(135deg, #007bff, #0056b3)', 
                    color: '#fff',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '16px 0',
                    fontWeight: 700,
                    boxShadow: '0 4px 16px rgba(0, 123, 255, 0.4)'
                  }} 
                  onClick={() => handleDownloadStoreVersion('global')}
                >
                  Скачать из Global App Store
                </button>
              </div>
            ) : (
              /* Для остальных платформ одна кнопка */
              <button 
                className="nvpn-btn nvpn-btn-orange-setup" 
                style={{
                  width:'100%',
                  fontSize:'1.1em',
                  marginTop:8,
                  borderRadius: '12px',
                  padding: '16px 0',
                  fontWeight: 700
                }} 
                onClick={handleConfirmDownload}
              >
                Хорошо, перейти к установке
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="App gradient-bg">
      {/* Анимированный Silk фон */}
      <Silk 
        speed={5}
        scale={1}
        color="#1a1e23"
        noiseIntensity={1.5}
        rotation={0}
      />
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        {step === 'choice' && renderChoiceStep()}
        {step === 'intro' && renderIntroStep()}
        {step === 'subscription' && renderSubscriptionStep()}
        {step === 'success' && renderSuccessStep()}
        {renderDownloadModal()}
      </div>
    </div>
  );
}

function handleSetupClick() {
  // Эта функция теперь будет заменена в App компоненте
}

function getPlatform() {
  const ua = navigator.userAgent;
  console.log('==> User Agent:', ua);
  
  // Приоритет проверки Telegram WebApp платформы
  if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.platform) {
    const tgPlatform = window.Telegram.WebApp.platform;
    console.log('==> Telegram Platform:', tgPlatform);
    if (tgPlatform === 'ios') return 'iOS';
    if (tgPlatform === 'android') return 'Android';
    if (tgPlatform === 'macos') return 'macOS';
    if (tgPlatform === 'web') {
      // На веб-версии Telegram дополнительно проверяем UserAgent
      if (/iPad|iPhone|iPod/.test(ua)) return 'iOS';
      if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(ua)) return 'macOS';
    }
  }
  
  // Стандартная проверка UserAgent
  if (/windows phone/i.test(ua)) return 'Windows';
  if (/android/i.test(ua)) return 'Android';
  if (/iPad|iPhone|iPod/.test(ua)) return 'iOS';
  if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(ua)) return 'macOS';
  if (/Win/.test(ua)) return 'Windows';
  
  return 'Unknown';
}

function handleSupport() {
  const tg = window.Telegram && window.Telegram.WebApp;
  
  if (tg) {
    console.log('==> Opening support dialog');
    
    // Попытка 1: Прямое открытие диалога через openTelegramLink
    if (typeof tg.openTelegramLink === 'function') {
      try {
        console.log('==> Trying openTelegramLink with tg://resolve');
        tg.openTelegramLink('tg://resolve?domain=nitroovpn_support');
        
        // Закрываем приложение после успешного открытия диалога
        if (typeof tg.close === 'function') {
          setTimeout(() => {
            console.log('==> Closing app after opening support dialog');
            tg.close();
          }, 300);
        }
        return;
      } catch (error) {
        console.log('==> openTelegramLink failed:', error);
      }
    }
    
    // Попытка 2: Альтернативный синтаксис для пользователя
    if (typeof tg.openTelegramLink === 'function') {
      try {
        console.log('==> Trying openTelegramLink with @username');
        tg.openTelegramLink('https://t.me/nitroovpn_support');
        
        // Закрываем приложение после успешного открытия
        if (typeof tg.close === 'function') {
          setTimeout(() => {
            console.log('==> Closing app after opening support dialog (method 2)');
            tg.close();
          }, 300);
        }
        return;
      } catch (error) {
        console.log('==> openTelegramLink with @username failed:', error);
      }
    }
    
    // Попытка 3: Использование openLink (откроется в браузере, но потом закроем приложение)
    if (typeof tg.openLink === 'function') {
      try {
        console.log('==> Using openLink as fallback');
        tg.openLink('https://t.me/nitroovpn_support');
        
        // Закрываем приложение чтобы пользователь мог перейти в Telegram
        if (typeof tg.close === 'function') {
          setTimeout(() => {
            console.log('==> Closing app to help user switch to Telegram');
            tg.close();
          }, 1000);
        }
        return;
      } catch (error) {
        console.log('==> openLink failed:', error);
      }
    }
    
    // Fallback: обычная ссылка
    console.log('==> Using fallback method');
    window.open('https://t.me/nitroovpn_support', '_blank');
  } else {
    // Для браузера без Telegram WebApp
    window.open('https://t.me/nitroovpn_support', '_blank');
  }
}

function ProfileScreen({ user, onBack, onPay, setUser, setScreen }) {
  const [showTransactions, setShowTransactions] = useState(false);
  const [showReferral, setShowReferral] = useState(false);
  const [showUserAgreement, setShowUserAgreement] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [userShortLink, setUserShortLink] = useState(null);
  const currentPlatform = getPlatform();
  
  // Создаем короткую ссылку для профиля при загрузке компонента (для всех платформ)
  useEffect(() => {
    const createProfileShortLink = async () => {
      try {
        const API_URL = window.location.hostname.includes('nitroovpn.ru')
          ? 'https://nitroovpn.ru'
          : '';
        
        console.log('==> Creating profile short link, API URL:', API_URL);
        
        const response = await fetch(`${API_URL}/api/config/create-short-link`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ telegram_id: user.telegram_id })
        });
        
        console.log('==> Profile short link response status:', response.status);
        
        if (response.ok) {
          const responseData = await response.json();
          console.log('==> Profile short link response data:', responseData);
          const { short_url } = responseData;
          setUserShortLink(short_url);
        } else {
          const errorText = await response.text();
          console.warn('Failed to create profile short link:', response.status, errorText);
        }
      } catch (error) {
        console.error('Error creating profile short link:', error);
      }
    };
    
    if (user?.telegram_id) {
      createProfileShortLink();
    }
  }, [user?.telegram_id]);
  
  // Удаляем заглушку транзакций - теперь они загружаются через API
  const handleSupport = () => {
    const tg = window.Telegram && window.Telegram.WebApp;
    
    if (tg) {
      console.log('==> Opening support dialog');
      
      // Попытка 1: Прямое открытие диалога через openTelegramLink
      if (typeof tg.openTelegramLink === 'function') {
        try {
          console.log('==> Trying openTelegramLink with tg://resolve');
          tg.openTelegramLink('tg://resolve?domain=nitroovpn_support');
          
          // Закрываем приложение после успешного открытия диалога
          if (typeof tg.close === 'function') {
            setTimeout(() => {
              console.log('==> Closing app after opening support dialog');
              tg.close();
            }, 300);
          }
          return;
        } catch (error) {
          console.log('==> openTelegramLink failed:', error);
        }
      }
      
      // Попытка 2: Альтернативный синтаксис для пользователя
      if (typeof tg.openTelegramLink === 'function') {
        try {
          console.log('==> Trying openTelegramLink with @username');
          tg.openTelegramLink('https://t.me/nitroovpn_support');
          
          // Закрываем приложение после успешного открытия
          if (typeof tg.close === 'function') {
            setTimeout(() => {
              console.log('==> Closing app after opening support dialog (method 2)');
              tg.close();
            }, 300);
          }
          return;
        } catch (error) {
          console.log('==> openTelegramLink with @username failed:', error);
        }
      }
      
      // Попытка 3: Использование openLink (откроется в браузере, но потом закроем приложение)
      if (typeof tg.openLink === 'function') {
        try {
          console.log('==> Using openLink as fallback');
          tg.openLink('https://t.me/nitroovpn_support');
          
          // Закрываем приложение чтобы пользователь мог перейти в Telegram
          if (typeof tg.close === 'function') {
            setTimeout(() => {
              console.log('==> Closing app to help user switch to Telegram');
              tg.close();
            }, 1000);
          }
          return;
        } catch (error) {
          console.log('==> openLink failed:', error);
        }
      }
      
      // Fallback: обычная ссылка
      console.log('==> Using fallback method');
      window.open('https://t.me/nitroovpn_support', '_blank');
    } else {
      // Для браузера без Telegram WebApp
      window.open('https://t.me/nitroovpn_support', '_blank');
    }
  };

  // Функция для открытия навигационного поста в Telegram канале
  const handleOpenInstructions = () => {
    const tg = window.Telegram && window.Telegram.WebApp;
    
    if (tg) {
      console.log('==> Opening instructions post');
      
      // Попытка 1: Прямое открытие поста через openTelegramLink
      if (typeof tg.openTelegramLink === 'function') {
        try {
          console.log('==> Trying openTelegramLink with direct post URL');
          tg.openTelegramLink('https://t.me/nitrooapp/32');
          
          // Закрываем приложение после успешного открытия
          if (typeof tg.close === 'function') {
            setTimeout(() => {
              console.log('==> Closing app after opening instructions post');
              tg.close();
            }, 300);
          }
          return;
        } catch (error) {
          console.log('==> openTelegramLink failed:', error);
        }
      }
      
      // Попытка 2: Использование openLink (откроется в браузере, но потом закроем приложение)
      if (typeof tg.openLink === 'function') {
        try {
          console.log('==> Using openLink as fallback');
          tg.openLink('https://t.me/nitrooapp/32');
          
          // Закрываем приложение чтобы пользователь мог перейти в Telegram
          if (typeof tg.close === 'function') {
            setTimeout(() => {
              console.log('==> Closing app to help user switch to Telegram');
              tg.close();
            }, 1000);
          }
          return;
        } catch (error) {
          console.log('==> openLink failed:', error);
        }
      }
      
      // Fallback: обычная ссылка
      console.log('==> Using fallback method');
      window.open('https://t.me/nitrooapp/32', '_blank');
    } else {
      // Для браузера без Telegram WebApp
      window.open('https://t.me/nitrooapp/32', '_blank');
    }
  };
  const handleCopyProfileLink = () => {
    if (!userShortLink) {
      alert('Ссылка на подписку еще подготавливается. Попробуйте через несколько секунд.');
      return;
    }
    navigator.clipboard.writeText(userShortLink);
  };

  // Функция для автоматического снятия фокуса с кнопок после клика
  const handleButtonClick = (callback, event) => {
    triggerHaptic();
    // Снимаем фокус с кнопки
    if (event && event.currentTarget) {
      event.currentTarget.blur();
    }
    // Выполняем callback
    if (callback) {
      callback();
    }
  };
      return (
      <div className="profile-card-bg">
        <div style={{fontWeight:700,fontSize:'1.15em',marginBottom:4, color:'#ea5022', textAlign:'center'}}>{user.username || '—'}</div>
        <div style={{color:'#ea5022',marginBottom:12, textAlign:'center'}}>id: {user.telegram_id}</div>
        <button className="profile-list-btn" style={{background:'rgba(24,28,32,0.68)'}} onClick={(e) => handleButtonClick(onPay, e)}>
          <ProfileIcon type="payment" />Оплата
        </button>
        <button className="profile-list-btn" style={{background:'rgba(24,28,32,0.68)'}} onClick={(e) => handleButtonClick(() => setShowTransactions(true), e)}>
          <ProfileIcon type="transactions" />Мои транзакции
        </button>
        <button className="profile-list-btn" style={{background:'rgba(24,28,32,0.68)'}} onClick={(e) => handleButtonClick(() => setShowReferral(true), e)}>
          <ProfileIcon type="referral" />Реферальная программа
        </button>
        <button className="profile-list-btn" style={{background:'rgba(24,28,32,0.68)'}} onClick={(e) => handleButtonClick(handleSupport, e)}>
          <ProfileIcon type="support" />Связаться с поддержкой
        </button>
        <button className="profile-list-btn" style={{background:'rgba(24,28,32,0.68)'}} onClick={(e) => handleButtonClick(() => setShowUserAgreement(true), e)}>
          <ProfileIcon type="agreement" />Пользовательское соглашение
        </button>
      <div className="profile-link-block">
        <div style={{fontSize: '0.98rem', color: '#ea5022', marginBottom: 6}}>
          Ссылка на подписку:
        </div>
        <div className="profile-link-row">
          <input 
            className="profile-link-input" 
            value={userShortLink || 'Подготавливаем ссылку...'} 
            readOnly 
          />
          <button className="profile-link-copy" onClick={(e) => handleButtonClick(handleCopyProfileLink, e)}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ background: 'none', outline: 'none' }}>
              <rect x="7" y="7" width="10" height="10" rx="3" stroke="#181c20" strokeWidth="2" fill="none"/>
              <rect x="3" y="3" width="10" height="10" rx="3" stroke="#181c20" strokeWidth="2" fill="none"/>
            </svg>
          </button>
        </div>
      </div>
      <button className="profile-instruction-btn" onClick={(e) => handleButtonClick(handleOpenInstructions, e)}>Инструкция для всех платформ</button>
      {showTransactions && <TransactionsModal user={user} onClose={() => { triggerHaptic(); setShowTransactions(false); }} />}
      {showReferral && <ReferralModal user={user} onClose={() => { triggerHaptic(); setShowReferral(false); }} />}
      {showUserAgreement && <UserAgreementModal onClose={() => { triggerHaptic(); setShowUserAgreement(false); }} />}
      {showUpgradeModal && user && (
        <UpgradeDevicesModal user={user} onClose={() => setShowUpgradeModal(false)} setUser={setUser} />
      )}
    </div>
  );
}

function showConfetti() {
  confetti({
    particleCount: 150,
    spread: 90,
    origin: { y: 0.6 },
    colors: ['#2196F3', '#F44336', '#4CAF50', '#9C27B0'] // синий, красный, зеленый, фиолетовый
  });
}

// Добавить универсальную функцию для вибрации
function triggerHaptic(type = 'soft') {
  const tg = window.Telegram && window.Telegram.WebApp;
  if (tg && tg.HapticFeedback && typeof tg.HapticFeedback.impactOccurred === 'function') {
    tg.HapticFeedback.impactOccurred(type);
  }
}



function App() {
  const platform = getPlatform();
  const [screen, setScreen] = useState('main');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [prevStatus, setPrevStatus] = useState(null);
  const [prevTariff, setPrevTariff] = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [isReferralModalOpen, setReferralModalOpen] = useState(false);
  const [isAgreementModalOpen, setAgreementModalOpen] = useState(false);
  const [setupStep, setSetupStep] = useState('choice'); // Управление шагами setup из App.js

  // Обработка контекста возврата после оплаты
  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes('return_context=')) {
      try {
        const contextMatch = hash.match(/return_context=([^&]+)/);
        if (contextMatch) {
          const returnContext = decodeURIComponent(contextMatch[1]);
          console.log('==> RETURN CONTEXT DETECTED:', returnContext);
          
          // Переключаемся на нужный экран в зависимости от контекста
          switch (returnContext) {
            case 'purchase':
              setScreen('purchase');
              break;
            case 'upgrade':
              setShowUpgradeModal(true);
              break;
            default:
              console.log('==> Unknown return context:', returnContext);
              break;
          }
          
          // Очищаем hash после обработки
          window.location.hash = '';
        }
      } catch (error) {
        console.error('Error processing return context:', error);
      }
    }
  }, []);

  // Стабилизируем функцию onBack для SetupScreen
  const handleSetupBack = useCallback(() => {
    console.log('==> Setup onBack called, returning to main');
    setScreen('main');
  }, []);



  // Единое состояние для выбора пользователя на экране оплаты
  const [paymentSelection, setPaymentSelection] = useState({
    tariffIndex: 0,
    devices: 1
  });

  // При инициализации пользователя или изменении его тарифа,
  // обновляем выбор по умолчанию для экрана оплаты.
  useEffect(() => {
    if (user && user.tariff && user.tariff !== 'trial') {
      const currentDevices = parseInt(user.tariff.match(/(\d+)devices$/)?.[1] || '1', 10);
      const currentTariffLabel = user.tariff.split('_')[0];
      const currentTariffIndex = TARIFFS.findIndex(t => t.label.replace(' ', '').toLowerCase() === currentTariffLabel);
      
      setPaymentSelection(prev => ({
        ...prev,
        tariffIndex: currentTariffIndex !== -1 ? currentTariffIndex : prev.tariffIndex,
        devices: currentDevices
      }));
    }
  }, [user]);

  // Используем useRef для получения актуального значения setupStep
  const setupStepRef = useRef(setupStep);
  setupStepRef.current = setupStep;

  // Управление Telegram BackButton
  useEffect(() => {
    console.log('==> App BackButton useEffect triggered, screen:', screen, 'setupStep:', setupStep);
    const tg = window.Telegram && window.Telegram.WebApp;
    if (!tg || !tg.BackButton) return;
    
    // Сначала очищаем предыдущие обработчики
    if (tg.BackButton.offClick) {
      tg.BackButton.offClick();
    }
    
    // Для setup экрана управляем навигацией между шагами
    if (screen === 'setup') {
      console.log('==> App managing BackButton for setup screen, step:', setupStep);
      tg.BackButton.show();
      const handler = () => { 
        const currentStep = setupStepRef.current;
        console.log('==> BackButton clicked on setup screen, current step:', currentStep);
        triggerHaptic(); 
        if (currentStep === 'choice') {
          console.log('==> Going back to main from choice');
          setScreen('main'); // С первого шага возврат в главное меню
        } else if (currentStep === 'intro') {
          console.log('==> Going back to choice from intro');
          setSetupStep('choice');
        } else if (currentStep === 'subscription') {
          console.log('==> Going back to intro from subscription');
          setSetupStep('intro');
        } else if (currentStep === 'success') {
          console.log('==> Going back to subscription from success');
          setSetupStep('subscription');
        } else {
          console.log('==> Fallback: going to main from:', currentStep);
          setScreen('main'); // Fallback
        }
      };
      tg.BackButton.onClick(handler);
    } else if (screen === 'purchase') {
      console.log('==> App managing BackButton for purchase screen');
      tg.BackButton.show();
      const handler = () => { triggerHaptic(); setScreen('main'); };
      tg.BackButton.onClick(handler);
    } else if (screen === 'profile') {
      console.log('==> App managing BackButton for profile screen');
      tg.BackButton.show();
      const handler = () => { triggerHaptic(); setScreen('main'); };  
      tg.BackButton.onClick(handler);
    } else if (screen === 'payment-profile') {
      console.log('==> App managing BackButton for payment-profile screen');
      tg.BackButton.show();
      const handler = () => { triggerHaptic(); setScreen('profile'); };
      tg.BackButton.onClick(handler);
    } else {
      console.log('==> App hiding BackButton for main screen');
      tg.BackButton.hide();
    }
    
    return () => {
      if (tg.BackButton && tg.BackButton.offClick) {
        tg.BackButton.offClick();
      }
    };
  }, [screen, setupStep]);

  useEffect(() => {
    const tg = window.Telegram && window.Telegram.WebApp;
    if (tg && tg.setHeaderColor) {
      if (screen === 'purchase') {
        tg.setHeaderColor('#020202');
      } else {
        tg.setHeaderColor('#020202');
      }
    }
  }, [screen]);

  useEffect(() => {
    let cancelled = false;
    let retryTimeout = null;

    const getTelegramLaunchData = () => {
      const webApp = window.Telegram?.WebApp;
      return {
        webApp,
        initData: webApp?.initData || '',
        user: webApp?.initDataUnsafe?.user || null,
        startParam: webApp?.initDataUnsafe?.start_param || ''
      };
    };

    const fetchUserWithPolling = async () => {
      setLoading(true);
      let attempts = 0;
      const maxAttempts = 30;
      const { webApp, startParam: initialStartParam } = getTelegramLaunchData();

      if (webApp && typeof webApp.ready === 'function') {
        try {
          webApp.ready();
        } catch (error) {
          console.warn('==> Telegram WebApp.ready failed:', error);
        }
      }

      console.log('==> Initialization with start_param:', initialStartParam);

      if (cancelled) return;

      const fetchData = async () => {
        if (cancelled) return;

        try {
          const { user: liveUser, startParam, initData } = getTelegramLaunchData();
          const currentUser = liveUser;
          const hasSignedInitData = typeof initData === 'string' && initData.includes('hash=');

          if (!currentUser?.id || !hasSignedInitData) {
            if (attempts >= maxAttempts) {
              setUser(null);
              setLoading(false);
              alert('Не удалось получить данные Telegram. На Windows откройте мини-приложение кнопкой бота и подождите 2–3 секунды.');
              return;
            }

            attempts++;
            retryTimeout = setTimeout(fetchData, attempts <= 8 ? 400 : 1000);
            return;
          }

          // Формируем display_name из first_name и last_name
          const display_name = currentUser.first_name && currentUser.last_name
            ? `${currentUser.first_name} ${currentUser.last_name}`
            : currentUser.first_name || currentUser.last_name || null;

          const res = await fetch('/api/user/init', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(buildUserInitBody({
              start_param: startParam || initialStartParam
            }))
          });

          if (!res.ok) {
            const err = await res.json();

            if ((err?.error === 'telegram_id required' || err?.error === 'invalid_init_data') && attempts < maxAttempts) {
              attempts++;
              retryTimeout = setTimeout(fetchData, 1000);
              return;
            }

            setUser(null);
            setLoading(false);
            alert('Ошибка: ' + (err.error || res.status));
            return;
          }

          const data = await res.json();

          // Пускаем в приложение, как только готова любая подписочная конфигурация.
          if (hasReadySubscriptionConfig(data) || attempts >= maxAttempts) {
            setUser(data);
            setLoading(false);
            if (!hasReadySubscriptionConfig(data)) {
              alert('Не удалось создать VPN-ключ. Пожалуйста, попробуйте перезапустить приложение или обратитесь в поддержку.');
            }
          } else {
            // Ключа еще нет, пробуем снова через 1 секунду
            attempts++;
            retryTimeout = setTimeout(fetchData, 1000);
          }
        } catch (e) {
          setUser(null);
          setLoading(false);
          alert('Ошибка соединения с сервером. Проверьте интернет и попробуйте снова.');
        }
      };

      fetchData();
    };

    fetchUserWithPolling();

    return () => {
      cancelled = true;
      if (retryTimeout) {
        clearTimeout(retryTimeout);
      }
    };
  }, []);

  useEffect(() => {
    if (user) {
      console.log('==> USER EFFECT: User changed', { 
        prevTariff, 
        currentTariff: user.tariff, 
        isTrialToPaid: prevTariff && user.tariff !== prevTariff && user.tariff !== 'trial'
      });
      // Показываем конфетти, если тариф изменился и стал не trial
      if (prevTariff && user.tariff !== prevTariff && user.tariff !== 'trial') {
        console.log('==> USER EFFECT: Launching confetti!');
        showConfetti();
      }
      setPrevTariff(user.tariff);
    }
  }, [user]);

  // Принудительно применяем стили кнопок для Telegram Web App
  useEffect(() => {
    const applyStyles = () => {
      setTimeout(() => {
        forceButtonStyles();
      }, 100);
    };

    // Применяем стили при загрузке компонента
    applyStyles();

    // Применяем стили при смене экрана
    applyStyles();
    
    // Глобальный обработчик кликов для восстановления стилей кнопок (особенно для Windows)
    const handleGlobalClick = (e) => {
      const button = e.target.closest('.nvpn-btn');
      if (button && (button.classList.contains('nvpn-btn-orange-main') || 
                     button.classList.contains('nvpn-btn-orange-setup') || 
                     button.classList.contains('nvpn-btn-orange-payment') || 
                     button.classList.contains('nvpn-btn-main') || 
                     (button.style.background && button.style.background.includes('ea5022')))) {
        // Восстанавливаем стили сразу после клика
        setTimeout(() => {
          if (button.classList.contains('nvpn-btn-orange-main')) {
            button.style.setProperty('background', 'linear-gradient(135deg, #ea5022, #d4451e)', 'important');
            button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
          } else if (button.classList.contains('nvpn-btn-orange-setup')) {
            button.style.setProperty('background', 'linear-gradient(135deg, #ff9100, #ff6f00)', 'important');
            button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
          } else if (button.classList.contains('nvpn-btn-orange-payment')) {
            button.style.setProperty('background', 'linear-gradient(90deg, #ea5022, #d4451e)', 'important');
            button.style.setProperty('border', '1px solid rgba(0, 0, 0, 0.2)', 'important');
          } else if (button.classList.contains('nvpn-btn-main')) {
            button.style.setProperty('background', 'linear-gradient(90deg, #ea5022, #d4451e)', 'important');
            button.style.setProperty('border', 'none', 'important');
          } else {
            button.style.setProperty('background', 'linear-gradient(135deg, #ea5022, #d4451e)', 'important');
            button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
          }
          button.style.setProperty('color', '#ffffff', 'important');
          button.style.setProperty('cursor', 'pointer', 'important');
          button.style.setProperty('transition', 'none', 'important');
          button.style.setProperty('WebkitTransition', 'none', 'important');
          button.style.setProperty('MozTransition', 'none', 'important');
        }, 1);
        
        // Дополнительная проверка
        setTimeout(() => forceButtonStyles(), 50);
        setTimeout(() => forceButtonStyles(), 200);
      }
    };
    
    // Добавляем глобальный слушатель
    document.addEventListener('click', handleGlobalClick, true);
    document.addEventListener('touchend', handleGlobalClick, true);

    // Дополнительные вызовы для мобильных устройств
    const isMobile = window.navigator && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
    if (isMobile) {
      console.log('🎨 Mobile device detected, applying additional style protection');
      
      // Дополнительные вызовы с разными интервалами для мобильных устройств
      setTimeout(forceButtonStyles, 200);
      setTimeout(forceButtonStyles, 500);
      setTimeout(forceButtonStyles, 1000);
      
      // Обработчик фокуса/блюра для мобильных устройств
      const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
          console.log('🎨 App became visible, reapplying button styles');
          setTimeout(forceButtonStyles, 100);
        }
      };
      
      document.addEventListener('visibilitychange', handleVisibilityChange);
      
      // Очищаем обработчик при размонтировании
      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    }

    // Наблюдаем за изменениями DOM и переприменяем стили
    const observer = new MutationObserver((mutations) => {
      let shouldReapply = false;
      
      mutations.forEach((mutation) => {
        // Проверяем, добавились ли новые кнопки или изменились стили
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              if (node.classList?.contains('nvpn-btn-dark') || 
                  node.classList?.contains('nvpn-btn-orange-main') ||
                  node.classList?.contains('nvpn-btn-orange-setup') ||
                  node.classList?.contains('nvpn-btn-orange-payment') ||
                  node.classList?.contains('nvpn-btn-main') ||
                  node.querySelector?.('.nvpn-btn-dark') ||
                  node.querySelector?.('.nvpn-btn-orange-main') ||
                  node.querySelector?.('.nvpn-btn-orange-setup') ||
                  node.querySelector?.('.nvpn-btn-orange-payment') ||
                  node.querySelector?.('.nvpn-btn-main')) {
                shouldReapply = true;
              }
            }
          });
        } else if (mutation.type === 'attributes' && 
                   (mutation.target.classList?.contains('nvpn-btn-dark') ||
                    mutation.target.classList?.contains('nvpn-btn-orange-main') ||
                    mutation.target.classList?.contains('nvpn-btn-orange-setup') ||
                    mutation.target.classList?.contains('nvpn-btn-orange-payment') ||
                    mutation.target.classList?.contains('nvpn-btn-main'))) {
          shouldReapply = true;
        }
      });
      
      if (shouldReapply) {
        setTimeout(forceButtonStyles, 50);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    return () => {
      observer.disconnect();
      document.removeEventListener('click', handleGlobalClick, true);
      document.removeEventListener('touchend', handleGlobalClick, true);
    };
  }, [screen, setupStep]);

  const handleButtonClick = (e, callback) => {
    const button = e.currentTarget;
    
    // Снимаем фокус
    button.blur();
    
    // Принудительно восстанавливаем стили для всех защищенных кнопок
    if (button.classList.contains('nvpn-btn-orange-main') || 
        button.classList.contains('nvpn-btn-orange-setup') || 
        button.classList.contains('nvpn-btn-orange-payment') || 
        button.classList.contains('nvpn-btn-main') || 
        (button.style.background && button.style.background.includes('ea5022'))) {
      
              setTimeout(() => {
        if (button.classList.contains('nvpn-btn-orange-main')) {
          button.style.setProperty('background', 'linear-gradient(135deg, #ea5022, #d4451e)', 'important');
          button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
        } else if (button.classList.contains('nvpn-btn-orange-setup')) {
          button.style.setProperty('background', 'linear-gradient(135deg, #ff9100, #ff6f00)', 'important');
          button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
        } else if (button.classList.contains('nvpn-btn-orange-payment')) {
          button.style.setProperty('background', 'linear-gradient(90deg, #ea5022, #d4451e)', 'important');
          button.style.setProperty('border', '1px solid rgba(0, 0, 0, 0.2)', 'important');
        } else if (button.classList.contains('nvpn-btn-main')) {
          button.style.setProperty('background', 'linear-gradient(90deg, #ea5022, #d4451e)', 'important');
          button.style.setProperty('border', 'none', 'important');
        } else {
          button.style.setProperty('background', 'linear-gradient(135deg, #ea5022, #d4451e)', 'important');
          button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
        }
        button.style.setProperty('color', '#ffffff', 'important');
        button.style.setProperty('cursor', 'pointer', 'important');
        button.style.setProperty('transition', 'none', 'important');
        button.style.setProperty('WebkitTransition', 'none', 'important');
        button.style.setProperty('MozTransition', 'none', 'important');
        button.style.setProperty('--tg-theme-button-color', 'transparent', 'important');
        button.style.setProperty('--tg-theme-button-text-color', '#ffffff', 'important');
      }, 1);
      
      // Дополнительная проверка через 100ms
      setTimeout(() => {
        if (button.classList.contains('nvpn-btn-orange-main')) {
          button.style.setProperty('background', 'linear-gradient(135deg, #ea5022, #d4451e)', 'important');
          button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
        } else if (button.classList.contains('nvpn-btn-orange-setup')) {
          button.style.setProperty('background', 'linear-gradient(135deg, #ff9100, #ff6f00)', 'important');
          button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
        } else if (button.classList.contains('nvpn-btn-orange-payment')) {
          button.style.setProperty('background', 'linear-gradient(90deg, #ea5022, #d4451e)', 'important');
          button.style.setProperty('border', '1px solid rgba(0, 0, 0, 0.2)', 'important');
        } else if (button.classList.contains('nvpn-btn-main')) {
          button.style.setProperty('background', 'linear-gradient(90deg, #ea5022, #d4451e)', 'important');
          button.style.setProperty('border', 'none', 'important');
        } else {
          button.style.setProperty('background', 'linear-gradient(135deg, #ea5022, #d4451e)', 'important');
          button.style.setProperty('border', '2px solid rgba(255, 255, 255, 0.2)', 'important');
        }
        button.style.setProperty('color', '#ffffff', 'important');
        button.style.setProperty('cursor', 'pointer', 'important');
        button.style.setProperty('transition', 'none', 'important');
        button.style.setProperty('WebkitTransition', 'none', 'important');
        button.style.setProperty('MozTransition', 'none', 'important');
      }, 100);
    }
    
    if (callback) callback();
  };

  if (loading || !user || !hasReadySubscriptionConfig(user)) {
    return <LoaderScreen />;
  }

  if (screen === 'purchase') {
    return <PurchaseScreen 
              user={user} 
              selection={paymentSelection}
              setSelection={setPaymentSelection}
              onBack={() => setScreen('main')} 
              setUser={setUser} 
            />;
  }

  if (screen === 'profile') {
    return (
      <div className="App gradient-bg">
        <Silk 
          speed={5}
          scale={1}
          color="#1a1e23"
          noiseIntensity={1.5}
          rotation={0}
        />
        <ProfileScreen user={user} onBack={() => setScreen('main')} onPay={() => setScreen('payment-profile')} setUser={setUser} setScreen={setScreen} />
      </div>
    );
  }

  if (screen === 'payment-profile') {
    return (
      <div className="App gradient-bg">
        <Silk 
          speed={5}
          scale={1}
          color="#1a1e23"
          noiseIntensity={1.5}
          rotation={0}
        />
        <PaymentProfileScreen onBack={() => setScreen('profile')} user={user} />
      </div>
    );
  }

  if (screen === 'setup') {
    return <SetupScreen user={user} onBack={handleSetupBack} step={setupStep} setStep={setSetupStep} />;
  }

  return (
    <div className="App gradient-bg">
      {/* Анимированный Silk фон */}
      <Silk 
        speed={5}
        scale={1}
        color="#1a1e23"
        noiseIntensity={1.5}
        rotation={0}
      />
      
      {/* Полностью скрываем главный экран при показе модального окна */}
      <div style={{ display: showUpgradeModal ? 'none' : 'block' }}>

        <div className="nvpn-center">
          <div style={{width:'100%',display:'flex',flexDirection:'column',alignItems:'center'}}>
            <div className="nvpn-card">
              {user && (
                <MainStatusCard user={user} setUser={setUser} showUpgradeModal={showUpgradeModal} setShowUpgradeModal={setShowUpgradeModal} onReturnToMain={() => setScreen('main')} />
              )}
              <button className="nvpn-btn nvpn-btn-orange-main" style={{fontWeight:700, animation:'shine 2s ease-in-out infinite', display:'flex', alignItems:'center', justifyContent:'center', gap:8}} onClick={(e) => { triggerHaptic(); handleButtonClick(e, () => setScreen('purchase')); }}>
                <BoltIcon width={22} height={22} style={{marginRight:8}} />
                {(() => {
                  // Проверяем есть ли у пользователя активная платная подписка
                  const hasActivePaidSubscription = user && 
                    user.tariff && 
                    user.tariff !== 'trial' && 
                    user.sub_end && 
                    new Date(user.sub_end) > new Date();
                  return hasActivePaidSubscription ? 'Продлить подписку' : 'Купить подписку';
                })()}
              </button>
              <button className="nvpn-btn nvpn-btn-orange-main" style={{fontWeight:700, animation:'shine 2s ease-in-out infinite', display:'flex', alignItems:'center', justifyContent:'center', gap:8}} onClick={e => { 
                triggerHaptic(); 
                handleButtonClick(e, () => {
                  setSetupStep('choice'); // Сбрасываем step при входе в setup
                  setScreen('setup');
                });
              }}>
                <PowerIcon width={22} height={22} style={{marginRight:8}} />
                <span style={{color:'#fff',fontWeight:700}}>Установка и настройка </span>
                <ShinyText text={platform} speed={1.5} />
              </button>
              <div className="nvpn-row">
                <button className="nvpn-btn nvpn-btn-half nvpn-btn-orange-main" style={{fontWeight:700, animation:'shine 2s ease-in-out infinite', display:'flex', alignItems:'center', justifyContent:'center', gap:8}} onClick={(e) => { triggerHaptic(); handleButtonClick(e, () => setScreen('profile')); }}>
                  <PasskeyIcon width={22} height={22} style={{marginRight:8}} />Профиль
                </button>
                <button className="nvpn-btn nvpn-btn-half nvpn-btn-orange-main" style={{fontWeight:700, animation:'shine 2s ease-in-out infinite', display:'flex', alignItems:'center', justifyContent:'center', gap:8}} onClick={(e) => { triggerHaptic(); handleButtonClick(e, () => handleSupport()); }}>
                  <CommunicationIcon width={22} height={22} style={{marginRight:8}} />Поддержка
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Модальное окно для апгрейда устройств */}
      {showUpgradeModal && user && (
        <UpgradeDevicesModal user={user} onClose={() => setShowUpgradeModal(false)} setUser={setUser} />
      )}
    </div>
  );
}



export default App;